{
  "settings" : {
    "calendar" : {
      "calendar_settings" : "Configurações do calendário",
      "settings" : "Configurações",
      "select_calendar_type" : "Selecionar o Tipo de calendário",
      "add_new_calendar_group" : "Adicionar novo Grupo de calendário",
      "add_new_equipment" : "Adicionar novo Equipamentos",
      "new_calendar" : "novo Calendário",
      "calendar_group_description" : "Use o Grupo de calendário para ordenar e agrupar com eficiência vários calendários.",
      "group" : "Grupo",
      "manage_your_calendars_and_groups" : "Gerencie seus calendários e grupo",
      "groups" : "Grupo",
      "create_group" : "Criar Grupo",
      "create_calendar" : "Criar calendário",
      "calendar_name" : "Nome do calendário",
      "group_duration" : "Duração do Grupo",
      "calendar_type" : "Digitar",
      "action" : "Ação",
      "round_robin" : "Rodízio",
      "event" : "Evento",
      "group_name" : "Nome do Grupo",
      "room_name" : "Nome da Sala",
      "group_description" : "Descrição do Grupo",
      "calendar_url" : "URL do calendário",
      "calendars" : "Calendários",
      "date_updated" : "Data de Atualizado",
      "status" : "Status",
      "action_dropdown" : "Lista suspensa de Ação",
      "calendar_list" : "Serviços Membros para",
      "edit" : "Editar",
      "duplicate" : "Duplicar",
      "copy_embed_code" : "Copiar Código de incorporação",
      "copy_permanent_link" : "Copiar Link permanente",
      "copy_new_slug_link" : "Copiar Link de programação",
      "copy_scheduling_link" : "Copiar Link de programação (anterior descontinuado)",
      "deactivate_calendar" : "Calendário do suspensor",
      "move_to_group" : "Mover para Grupo",
      "delete_calendar" : "Excluir calendário",
      "delete_group" : "Excluir",
      "delete_this_group" : "Excluir este grupo",
      "activate_calendar" : "Calendário de gatilho",
      "duration" : "Duração",
      "all" : "todos",
      "draft" : "Rascunhar",
      "inactive" : "Inativo",
      "active" : "Dinâmico",
      "actions" : "atividades",
      "rearrange_calendars" : "Reagendar Calendários",
      "deactivate_all_calendars_in_group" : "Suspender todos os calendários in grupo",
      "activate_all_calendars_in_group" : "gatilho todos os calendários in Grupo",
      "no_groups_found" : "Seu Pesquisar não correspondeu a nenhum calendário do Grupo.",
      "no_groups_in_location" : "Grupo Ordenar seus calendários Curtir Pasta. Adicione calendários a um grupo e compartilhe um Link individuais de programação, permitindo que a Agendador selecione de vários calendários.",
      "no_calendars_found" : "Comece Via calendário Via calendário criado novo.",
      "no_calendars_found_search" : "Seu Pesquisar não correspondeu a nenhum calendário.",
      "delete_calendar_message" : "Você está Sobre para excluir o calendário. Quando Você Visualizações excluir, também excluirá todos o seu compromisso.",
      "delete_calendar_message_title" : "Excluir este calendário?",
      "duplicate_calendar_message" : "Você está sobre a Duplicar Calendário. Isso criará um novo calendário com as mesmos configurações do calendário selecionado.",
      "duplicate_calendar_message_title" : "Duplicar este calendário?",
      "no_calendars_found_title" : "Nenhum calendário encontrado",
      "no_groups_in_location_title" : "Nenhum grupo encontrado",
      "delete_group_confirmation_title" : "Excluir este Grupo?",
      "delete_group_confirmation" : "Tem certeza de que deseja excluir o selecionado grupo?",
      "delete_group_confirmation_checkbox_title" : "Excluir calendários e compromissos de Membros",
      "delete_group_confirmation_checkbox_description" : "Selecionar esta opção também excluirá os calendários in grupo, junto com todos o compromisso in calendários.",
      "group_status_message_title" : "{status} Grupo e todos Membros Calendários?",
      "calendar_status_message_title" : "{status} este calendário?",
      "calendar_status_message" : "Você está sobre para {status} Calendário",
      "group_status_active_message" : "Tem certeza de que deseja ativar este grupo? todos os calendários dentro do grupo também serão habilitados e disponíveis para reserva",
      "group_status_inactive_message" : "Tem certeza de que deseja suspender este grupo? todos os calendários dentro do grupo também ficarão desabilitados e disponíveis para reserva",
      "coming_soon" : "Em breve",
      "select" : "Selecionar",
      "15mins" : "15 minutos",
      "cancel" : "Cancelar",
      "save" : "Arquivar",
      "create" : "Criar",
      "select_calendar_group" : "Selecionar Grupo de calendário",
      "move_calendar_confirmation" : "Observe que o Link antigo para de funcionar uma vez Você Prosseguir com o Alterar. Confirme a Via selecionando a Caixa de seleção.",
      "previously_called_unassigned" : " (anteriormente chamado como não atribuído)",
      "scheduling_type" : "Selecionar tipo de calendário",
      "scheduling_type_description" : "selecionar um tipo de calendário para a configuração do seu calendário e personalizar como o compromisso é programado.",
      "service_menu_name" : "Nome do menu de serviços",
      "template" : "Modelo",
      "select_template" : "Selecionar modelo",
      "group_url" : "URL do Grupo",
      "template_description" : "Você agora tem a opção de selecionar Ou os modelos do Clássico Ou Neo para o Grupo Visualizar",
      "rooms" : "Sala",
      "rooms_name" : "Nome",
      "rooms_description" : "Descrição",
      "rooms_modal_description" : "Adicionar ou editar sala",
      "rooms_capacity" : "Capacidade Total",
      "no_rooms_in_location_title" : "Nenhuma sala encontrada",
      "no_rooms_in_location" : "Nenhuma sala encontrada in localização",
      "no_equipments_in_location" : "Nenhum equipamentos encontrado in localização",
      "equipments" : "Equipamentos",
      "equipment_name" : "Nome",
      "equipment_name_search" : "Nome do Equipamentos",
      "equipment_description" : "Descrição",
      "equipment_modal_description" : "Adicionar ou editar um equipamentos",
      "add_equipment" : "Adicionar/ Editar Equipamentos",
      "add_room" : "Adicionar/ Editar Sala",
      "equipment_quantity" : "Quantidade Total",
      "equipment_outOfService" : "Quantidade de serviço",
      "no_equipments_in_location_title" : "Nenhum equipamentos encontrado",
      "delete_this_equipment" : "Excluir este Equipamentos",
      "delete_this_rooms" : "Excluir esta sala",
      "delete_equipment_confirmation" : "Tem certeza de que deseja excluir este Equipamentos? Este será o Apagado de todos os Calendários externos também.",
      "delete_rooms_confirmation" : "Tem certeza de que deseja excluir esta Sala? Este será o Apagado de todos os Calendários externos também.",
      "add_new_calendar_equipments" : "Adicionar novo Equipamentos",
      "no_equipments_found" : "Seu Pesquisar não correspondeu a nenhum Equipamentos.",
      "no_rooms_found" : "Seu Pesquisar não correspondeu a nenhuma Sala.",
      "add_new_calendar_rooms" : "Adicionar nova Sala",
      "rooms_disable" : "Desabilitar Sala",
      "equipments_disable" : "Desabilitar Equipamentos",
      "equipments_activate" : "gatilho Equipamentos",
      "rooms_activate" : "gatilho Sala",
      "create_equipments" : "Criar Equipamentos",
      "create_rooms" : "Criar Sala",
      "select_calendar_rooms_title" : "Selecionar calendário",
      "select_calendar_rooms_description" : "Você pode selecionar vários calendários para o Afiliado com a Sala",
      "select_calendar_equipments_title" : "Selecionar calendário",
      "select_calendar_equipments_description" : "Você pode selecionar um calendário para Afiliado com os Equipamentos",
      "disable_equipment_title" : "{status} Equipamentos",
      "disable_room_title" : "{status} Sala",
      "equipments_status_message" : "Tem certeza de que deseja {status} este Equipamentos?",
      "rooms_status_message" : "Tem certeza de que deseja {status} esta sala?",
      "calendar_resource_disclaimer" : "Isso pode afetar os calendários de serviços da Disponibilidade Ativado Membros.",
      "equipment_disclaimer" : "Observação: habilitar os Equipamentos mais tarde o reconectará automaticamente aos calendários com os seus Membros",
      "room_disclaimer" : "Observação: habilitar a Sala mais tarde a reconectará automaticamente aos calendários com os quais são Membros",
      "equipment_tab_name" : "Equipamentos",
      "rooms_tab_name" : "Sala",
      "manage_your_rooms" : "Gerenciar a sala para sua empresa aqui",
      "manage_your_equipments" : "Gerenciar Equipamentos para sua Empresa aqui",
      "select_service_calendar_description_equipments" : "Você pode selecionar vários calendários de serviços para o Afiliado com Equipamentos",
      "select_service_calendar_description_rooms" : "Você pode selecionar vários calendários de serviços para o Afiliado com a Sala",
      "service_menus" : "Menu de serviços",
      "manage_your_calendars_groups_and_service_menus" : "Gerencie seus calendários, grupo e menu de serviços",
      "new_service_menu" : "Criar menu de serviços",
      "deactivate_service_menu" : "Suspender menu de serviços",
      "delete_service_menu" : "Excluir este menu de serviços",
      "delete_service_menu_confirmation" : "Tem certeza de que deseja excluir este menu de serviço?",
      "service_menu_status_message_title" : "{status} este menu de serviços?",
      "service_menu_status_message" : "Você está sobre o {status} menu de serviços",
      "no_service_menus_in_location_title" : "Criar seu menu de serviços personalizado",
      "add_new_service_menu" : "Adicionar novo menu de serviços",
      "no_service_menus_in_location" : "Iniciar a Via Criado um novo menu de serviço e adicionar o Grupo a ele",
      "no_service_menu_found" : "Nenhum menu de serviços encontrado",
      "no_service_menu_found_desc" : "Seu Pesquisar não correspondeu a nenhum menu de serviço.",
      "apply" : "Aplicar",
      "troubleshoot_calendar" : "Solucionar problemas de calendário",
      "round_robin_booking" : "Rodízio",
      "round_robin_description" : "Distribuição de compromissos entre o Grupo Membros in um Ordenar móvel.",
      "round_robin_example" : "Por exemplo: ligações de vendas, sessões de integração.",
      "unassigned_booking" : "Calendário de Evento",
      "unassigned_description" : "Para ocorrências físicos Programar sem proporção de Host .",
      "unassigned_example" : "Por exemplo: Conferências, webinars do Público, mostras.",
      "event_booking_alert_title" : "Importante",
      "event_booking_alert_message" : "Este tipo de calendário apresenta diferenças importantes",
      "event_booking_know_more" : "Saiba mais",
      "event_booking_tooltip_title" : "Coisas importantes:",
      "event_booking_tooltip_content" : "• Não há suporte para ferramentas de link de conferências dinâmicas (ex.: Zoom/Google Meet/MS Teams)\n • Não é possível atribuir nenhum usuário\n • Os eventos não são sincronizados com o calendário do usuário, por padrão.\n • Apenas um único Google Agenda pode ser sincronizado por meio da Sincronização externa.\n • Não há suporte para calendários conflitantes.",
      "class_booking" : "Reserva de Aula",
      "class_booking_description" : "Um Host atende com vários Membros.",
      "class_booking_example" : "Por exemplo: Webinars, Grupo Cursos, Cursos on-line.",
      "collective_booking" : "Reservas COLETIVO",
      "collective_booking_description" : "Vários Hosts se conhecem com um Membros.",
      "collective_booking_example" : "Por exemplo: conversas de painel, avaliações de Conselhos.",
      "service_booking" : "Reserva de serviço",
      "service_booking_description" : "Programação perfeita para empresas baseada em serviços.",
      "service_booking_example" : "Por exemplo: Compromisso de spam, Serviços de revisão, consultas.",
      "personal_booking" : "Reserva pessoal",
      "personal_booking_description" : "Programar uma reunião-ativada com um Grupo específico de Membros.",
      "personal_booking_example" : "Por exemplo: Reuniões de clientes, consultas privada.",
      "personal" : "Pessoal",
      "explore_more_types" : "explore mais categorias",
      "no_calendars_added" : "Ainda não há calendários - Coleção One Upload!",
      "no_calendars_added_description" : "Crie seu primeiro calendário para iniciar o Programar sem esforço.",
      "no_groups_added" : "Ainda não há grupo - Comece a se organizar!",
      "no_calendars_yet" : "Ainda não há calendários",
      "no_groups_yet" : "Ainda não há grupo",
      "no_calendars_access" : "Nenhum calendário foi criado ainda. Depois que um calendário for criado, ele aparecerá aqui. Você não tem Acesso para criar um calendário — entre em contato com seu administrador se precisa.",
      "no_groups_access" : "Nenhum grupo ainda está configurado. Depois que um grupo for criado, ele aparecerá aqui. Você não tem Acesso para Criar um Grupo — entre em contato com seu administrador se necessário.",
      "no_groups_added_description" : "Use o Grupo para manter seus calendários configurados. Adicionar calendários a um grupo e compartilhar um Link de grupo Indivíduo de programação para reserva descompromisso.",
      "group_success_message" : "O grupo é criado com sucesso. Você pode agora incluir calendários a este grupo.",
      "choose_calendars" : "Selecionar Calendários",
      "do_it_later" : "Fazer mais tarde",
      "add_calendars_to_group" : "Adicionar Calendários ao Grupo",
      "select_calendars_to_add" : "Selecione todos os calendários Você deseja Incluir ao Grupo {name}",
      "add_calendars" : "Adicionar calendário(s)",
      "continue" : "Continuar",
      "conflicting_calendars" : "Calendários conflitantes",
      "conflicting_calendars_description" : "Os calendários posteriores já fazem parte de Outro Grupo. Você quer mova-os para seu novo grupo, <b>{name}</b>?",
      "group_associated_with" : "Grupo Atual",
      "move_calendar_consent" : "I Habilitar Movendo estes calendários para o novo Grupo.",
      "calendars_moved_successfully" : "todos os calendários selecionados foram movidos com sucesso para {name}.",
      "new_group" : "novo Grupo",
      "back" : "Voltar",
      "share_otl" : "Compartilhe sua Disponibilidade todos os dados com um Link exclusivo que Vence Depois de uma reserva, certifique-se de gerenciar o acesso.",
      "copied_to_clipboard" : "Copiado para a área de transferência",
      "generate_link" : "Gerar novo Link",
      "generate_link_error" : "Não foi possível gerar um link único. Tente novamente",
      "share_schedule_link" : " O Link de programação é definido Via o Slug. Modifique o Slug, e o Link de programação se dade automaticamente à alteração.",
      "share_permanent_link" : "Ideal para Funis, Redirecionamentos de Website , Ou Anúncios, o Link permanente permanece permanente, não afetada Via Slug Dinâmico.",
      "copy" : "Copiar",
      "share_embed_code" : "Localização este código in seu HTML , onde Você deseja que seu Widget {embedType} aparece.",
      "scheduling_link" : "Link de programação",
      "permanent_link" : "Link permanente",
      "one_time_link" : "Um Linkde dados",
      "embed_code" : "Código de incorporação",
      "loading" : "Carregando...",
      "share_group" : "Compartilhar Grupo",
      "edit_group" : "Editar Grupo",
      "more_options" : "Mais Opções",
      "share_calendar" : "Compartilhar calendário",
      "edit_calendar" : "Editar calendário",
      "troubleshoot_calendar_link" : "Solucionar problemas de calendário",
      "calendar_config_success" : "Você configurado com sucesso seu calendário pessoal/de grupo",
      "close" : " Fechar",
      "added_calendars" : "Calendário(s) adicionado(s)",
      "select_calendars" : "Selecionar calendário(s)",
      "settings_confirmation" : "Para a Prosseguir, confirme essas Dinâmico.",
      "consent_checkbox_title" : "Entendo e aceito essas Dinâmico",
      "confirm" : "Confirmar",
      "create_group_access_disabled" : "Você não tem autorização para Criar um grupo. Contato seu administrador para Acesso.",
      "create_calendar_access_disabled" : "Você não tem autorização para criar um calendário. Contato seu administrador para Acesso.",
      "preview_booking_widget" : "Pré-visualizar o Widget de agendamento",
      "share_service_menu" : "Compartilhar menu de serviços",
      "back_message" : "Voltar para a Lista de calendários",
      "service_calendars" : "Calendários de serviços",
      "owned_by" : "Via de proprietário",
      "owned_by_anyone" : "Qualquer pessoa",
      "owned_by_me" : "Eu",
      "all_groups" : "todos Grupo",
      "all_calendars" : "todos Calendários",
      "not_grouped" : "Não agrupado",
      "delete_group_desc" : "Tem certeza de que deseja excluir este grupo? Isso também apagará todos os calendários Membros com este grupo.",
      "calendar_listing_title" : "Listagem de calendário",
      "calendar_group_name" : "Calendário/nome do Grupo",
      "success" : "Sucesso",
      "my_calendar" : "meu-calendário"
    },
    "preferences" : {
      "preferences" : "Configurações",
      "my_preferences" : "Minha Preferência",
      "account_preferences" : "Preferências da conta",
      "user_preferences" : "Número de usuários",
      "set_preferences" : "Coleção suas configurações para sua conta.",
      "scheduling_options" : "Opções do programa",
      "meeting_location" : "Conferência encontrada",
      "zoom" : "Zoom",
      "save_preferences" : "Configurações da Arquivar",
      "in_app_preferences" : "Nenhuma configuração do app",
      "set_start_day" : "Coleção Configurações",
      "view_options" : "Visualizar Opções",
      "services" : "Serviços",
      "feature_toggle_aria" : "Alternância de recurso",
      "week_starts_on" : "Início da semana",
      "sunday" : "domingo",
      "widget_preferences" : "Configurações Widget",
      "set_widget_language" : "Coleção Configurações Curtir Idioma para Widget",
      "language_and_region" : "Idioma e Estado",
      "language" : "Idioma",
      "english" : "Ingls",
      "time_format" : "Formato de hora",
      "time_format_value" : "1:30 PM",
      "monday" : "segunda-feira",
      "custom_meeting_location" : "Personalizado Conferência de localização",
      "view_appointments_in_1" : "Visualizar agendamentos em",
      "timezone_uses_details_1" : "Usaremos este fuso horário para exibir os horários dos agendamentos no app e nos seus e-mails relacionados a agendamentos — apenas para você. Isso não afetará a sua disponibilidade nem os agendamentos de outras pessoas com você.",
      "business_timezones_1" : "Fuso horário da empresa",
      "business_timezones_tooltip_1" : "Mensagem: Escolher esta opção garante que sua Preferência de visualização esteja alinhada com o Fuso horário da Empresa selecionado. Se o fuso horário da Empresa mudar, seu fuso horário de visualização será automaticamente ajustado para corresponder.",
      "recommended_timezones" : "Fusos horários recomendados",
      "all_timezones" : "Todos os fusos horários"
    },
    "availability" : {
      "availability" : "Disponibilidade",
      "my_availability" : "Minha Disponibilidade",
      "my_availability_and_booking_rules" : "Disponibilidade e regras de agendamento",
      "my_availability_and_booking_rules_description" : "Configure sua disponibilidade e defina como e quando este calendário aceita agendamentos, incluindo intervalos de reuniões, limites e outras preferências de programação.",
      "account_availability" : "Disponibilidade da Conta",
      "timezone" : "Fuso horário",
      "working_hours" : "Horários de trabalho",
      "set_recurring_hours" : "Coleção sua hora de trabalho recorrente para a Conferência",
      "select_one" : "Selecionar um",
      "sunday" : "domingo",
      "monday" : "segunda-feira",
      "tuesday" : "Terça-feira",
      "wednesday" : "Quarta-feira",
      "thursday" : "Quinta-feira",
      "friday" : "sexta-feira",
      "saturday" : "sábado",
      "widget_preferences" : "Configurações Widget",
      "set_widget_language" : "Coleção Configurações Curtir Idioma para Widget",
      "language_and_region" : "Idioma e Estado",
      "language" : "Idioma",
      "english" : "Ingls",
      "copy_to_all" : "Copiar para todos",
      "save_availability" : "Arquivar Disponibilidade",
      "add_time" : "Adicionar dados",
      "to" : "Para",
      "select_time" : "Selecionar dados",
      "add_user" : "Adicionar Usuário",
      "accessRestricted" : {
        "header" : "Acesso privado",
        "message" : "Você não faz parte desta conta. Para obter acesso, inclua a si mesmo a esta Conta Via Agência Configurações > Grupo > Editar Grupo Membros e atribua a conta em 'Funções e permissões'",
        "contact_admin" : "Esta página é pública apenas para administradores. Entre em contato com seu administrador para obter assistência.",
        "button_text" : "Vá para Configurações da Agência"
      },
      "schedule" : {
        "edit_schedule" : "Editar programação",
        "schedule_name" : "Nome da programação",
        "schedule_name_required" : "O nome da programação é obrigatório",
        "timezone" : "Fuso horário",
        "timezone_placeholder" : "Selecione um",
        "start_time" : "Hora de início",
        "end_time" : "Hora de término",
        "add_availability_hour" : "Adicionar hora de disponibilidade",
        "remove_availability_hour" : "Remover hora de disponibilidade",
        "unavailable" : "Indisponível",
        "schedule_created" : "Programação criada com sucesso",
        "schedule_updated" : "Programação atualizada com sucesso",
        "calendars_selected" : "{count} Calendário",
        "calendars_selected_multiple" : "{count} calendários",
        "select_users_placeholder" : "Pesquisar usuários",
        "edit_default_schedule" : "Editar esta programação",
        "customize_event_type_schedule" : "Personalizar a programação apenas para este calendário",
        "multi_user_description" : "<b>{count} usuários</b> estão selecionados, atualize a disponibilidade deles para <b>{calendar}</b>",
        "selected_calendar" : "calendário selecionado",
        "edit_schedule_alert" : "As atualizações feitas aqui serão aplicadas a",
        "schedule" : "Programar",
        "no_availability" : "Sem disponibilidade",
        "date_specific_hours_show_more" : "mais",
        "date_specific_hours_show_less" : "menos",
        "date_specific_hours_recurring_meetings_enabled" : "Não é possível adicionar horários específicos da data porque esta programação está vinculada a um calendário com reuniões recorrentes habilitadas. Para continuar, desabilite as reuniões recorrentes.",
        "recurring_incompatible_with_date_hours" : "Reuniões recorrentes não podem ser habilitadas porque a programação do usuário tem horários específicos da data, o que é incompatível.",
        "incompatible_schedule_with_recurring" : "A programação {user} contém horários específicos para datas, o que é incompatível com reuniões recorrentes.",
        "incompatible_schedule_with_recurring_calendar" : "A programação contém horários específicos para datas, o que é incompatível com reuniões recorrentes.",
        "recurring_meetings_enabled_multi_user" : "Reuniões recorrentes exigem somente um membro da equipe atribuído, e sua programação não deve incluir horários específicos da data.",
        "weekdays" : "Dias úteis, {timeRange}",
        "weekdays_hours_vary" : "Dias úteis, horário variável",
        "weekend" : "Fim de semana, {timeRange}",
        "weekend_hours_vary" : "Fim de semana, horário variável",
        "days_hours_vary" : "{days}, horário variável",
        "date_specific_hours_tab_name" : "Horários específicos da data",
        "date_specific_hours" : "{count} horários específicos da data",
        "date_specific_hours_1" : "1 horário específico da data",
        "weekly_hours" : "Horário Semanal",
        "custom_schedule" : "Programação personalizada",
        "select_schedule" : "Selecione uma programação",
        "no_schedules_found" : "Nenhuma programação encontrada",
        "untitled" : "Sem título",
        "error_updating_schedules" : "Erro ao atualizar as programações",
        "daily" : "Diário",
        "weekly" : "Semanalmente",
        "monthly" : "Mensalmente",
        "custom" : "Personalizado",
        "this_is_required" : "Isto é obrigatório",
        "search" : "Pesquisar",
        "edit_hours" : "Editar horário",
        "schedule_name_duplicate" : "Já existe uma programação com este nome",
        "delete_schedule_title" : "Excluir a programação '{scheduleName}'?",
        "delete_schedule_description" : "Essa ação não pode ser desfeita. Tem certeza de que deseja continuar?",
        "delete_schedule_negative_text" : "Cancelar",
        "delete_schedule_positive_text" : "Sim, excluir",
        "active_on" : "Habilitado em",
        "weekly_working_hours" : "Horário de trabalho semanal",
        "weekly_working_hours_subtext" : "Selecione os dias e horários em que você trabalha",
        "copy_availability_hour" : "Copiar hora de disponibilidade",
        "mins" : "Minutos",
        "hours" : "Horas"
      }
    },
    "connections" : {
      "connections" : "Conexões",
      "connect" : "conectar",
      "conferencing" : "Conferência",
      "my_connections" : "Minhas conexões",
      "account_connections" : "Conexões da Conta",
      "connection_preferences" : "Configurações de conexão",
      "manage_calendars_conferencing_channels" : "Gerenciar calendários e canais de Conferência",
      "main_integration_calendar" : "PRINCIPAL Calendário de integração",
      "event_integration_calendar" : "ocorrências criadas ativadas a um calendário do sistema do qual Você faz parte também serão criadas ativadas neste calendário integrado",
      "2way_sync" : "Sincronização de duas via: Criar Sistema ocorrências De ocorrências reservadas Ativado o PRINCIPAL calendário integrado",
      "calendars" : "Calendários",
      "google" : "Google",
      "outlook" : "Outlook",
      "check_for_conflicts" : "Marca de verificação para conflitos",
      "choose_accounts_to_connect" : "selecione qual Conta Você deseja conectar",
      "payments" : "Pagamentos",
      "stripe" : "Stripe",
      "ads" : "Anúncios",
      "local_service_ads" : "Anúncios de serviços locais",
      "fire_workflow" : "Disparador de fluxo de trabalho para ocorrências reservadas Via sincronização bidirecional",
      "connect_google_outlook" : "Conecte sua conta Google/Outlook/iCloud para poderá selecionar o calendário PRINCIPAL.",
      "execute_automation" : "Executar automação",
      "save" : "Arquivar",
      "lsa" : "Anúncios de serviços locais",
      "no_write_access" : "Você não escrever Acesso a este calendário",
      "connection_remove_confirmation" : "Você está sobre para remover esta integração",
      "active" : "Dinâmico",
      "icloud" : {
        "title" : "Integração iCloud",
        "description" : "A autenticação de dois fatores e uma password específicas do aplicativo são obrigatórias para conectar sua Conta.",
        "email" : "Endereço de e-mail iCloud",
        "password" : "iCloud",
        "connect" : "Conectar",
        "cancel" : "Cancelar"
      }
    }
  },
  "appointment_modal" : {
    "select_a_contact" : "Selecionar um Contato",
    "start_time" : "Dados de início",
    "unassigned" : "Não atribuído",
    "end_time" : "Dados de Fim",
    "search_by_name_email_phone_or_company" : "Pesquisar Via nome, E-mail, Telefone Ou Empresa",
    "add_new" : "Adicionar novo",
    "pick_from_available_contacts" : "Ou selecionar de Amigos disponíveis",
    "book_appointment" : "Agendar Compromisso",
    "add_blocked_off_time" : "Adicionar dados desabilitados bloqueados",
    "recommended_timezones" : "Fusos horários Recomendado",
    "all_timezones" : "todos os fusos horários",
    "calendar" : "Calendário",
    "repeat" : "Repetição",
    "date_and_time" : "Dados e estatísticas",
    "close" : "Fechar",
    "team_member" : "Grupo Membros",
    "recurring_booking" : "Reserva Recorrente",
    "one_slot_booking" : "Reserva de um intervalo",
    "event_type" : "Tipo de evento",
    "occurrences_booked" : "ocorrências serão reservadas",
    "repeats" : "Repete",
    "booking_details" : "Detalhes do agendamento",
    "showing_slots_in_this_timezone" : "Exibindo intervalos in fuso horário:",
    "update_contact_tz" : "Também atualize o fuso horário de Contato para",
    "date" : "Data",
    "slot" : "intervalo",
    "calendar_default" : "Calendário Padrão",
    "custom" : "Personalizado(a)",
    "meeting_notes" : "(por exemplo) Notas de conferência para nosso próximo compromisso",
    "out_of_office" : "(por exemplo) De story para a Semana!",
    "standard" : "Padrão",
    "appointment_title" : "Título do Compromisso",
    "event_title" : "Título do Evento",
    "appt_with_bob" : "(por exemplo) Compromisso com João",
    "vacation" : "(por exemplo) férias",
    "show_notes" : "Exibir observações",
    "hide_notes" : "Ocultar observações",
    "additional_preferences" : "Configurações adicionais",
    "meeting_location" : "Conferência encontrada",
    "appointment_status" : "Status do Compromisso",
    "appt_description" : "Descrição do Compromisso",
    "recurring_details" : "Detalhes Recorrente",
    "event_description" : "Descrição do Evento",
    "in_contact_timezone" : "in fuso horário do contato",
    "vacation_message" : "Vai sair de férias Ativado? Vai tirar alguns dados desabilitado? Bloquear dados desabilitados, ative seu calendário para evitar que a reserva de clientes Compromisso atual ainda permanecerá ativada em seu calendário).",
    "contact" : "Contato",
    "delete" : "Excluir",
    "cancel" : "Cancelar",
    "back" : "Voltar",
    "pick_available_contacts" : "Ou selecionar de Amigos disponíveis",
    "no_contacts_found" : "Nenhum parceiro encontrado",
    "found" : "encontrado",
    "select_one" : "Selecionar um(a)",
    "tz_tooltip" : "Isso só importa Se Você está Via Valores personalizados; como Compromisso Compromisso Compromisso etc.. in suas Enviadas Comunicação com seus Clientes Ou Clientes. E o que ele simplesmente faz é converter os detalhes acima mencionados em seus dados locais.",
    "meeting_location_tooltip" : "A Conferência Localização será a coleção, conforme configurado in calendário.",
    "appt_meeting_location_tooltip" : "O usuário pode a coleção a Conferência Localização específicas do compromisso.",
    "gmeet_tooltip" : "Crie certeza de que os respectivos Grupos Membros tenham uma Coleção de Agenda Google como calendário PRINCIPAL",
    "zoom_tooltip" : "Criar certifique-se de que os respectivos Grupos Membros tenham Zoom integrado",
    "enter_meeting_location" : "Digite a conferência localização",
    "save_appointment" : "Arquivar Compromisso",
    "save_event" : "Arquivar evento",
    "search_contacts" : "Pesquisar Via nome, E-mail, Telefone Ou Empresa",
    "recurring_slots" : "{recurringSlotsLength}/{count}",
    "custom_timezone" : "Fuso horário Personalizado",
    "system_timezone" : "Fuso horário do Sistema",
    "contact_timezone" : "Fuso horário de Contato",
    "account_timezone" : "Fuso horário da Conta",
    "an_error_occurred" : "Ocorreu um erro"
  },
  "popup" : {
    "calendar" : "Calendário",
    "appointment_owner" : "Proprietário do Compromisso",
    "source" : "Fonte",
    "booked_by" : "Agendado Via",
    "view_activity_log" : "Visualizar Registro de atividades",
    "status" : "Status",
    "cancel_appointment" : "Cancelar Compromisso",
    "cancel_all" : "Cancelar todos",
    "google_event" : "Evento do Google",
    "outlook_event" : "Evento do Outlook",
    "blocked_slot" : "Intervalo bloqueado",
    "appointment" : "Compromisso",
    "confirmed" : "Confirmado",
    "unconfirmed" : "Não confirmado",
    "cancelled" : "Cancelado",
    "showed" : "Comparecido",
    "no_show" : "Não comparecimento",
    "invalid" : "Inválido",
    "more" : "Mais",
    "less" : "Menor",
    "edit" : "Editar",
    "reschedule_all" : "Reagendar todos",
    "guests" : "Convidado(s)",
    "guest_count" : "Contagem de Convidado(s)"
  },
  "create_calendar" : {
    "calendar_name" : "Nome do calendário",
    "calendar_logo" : "Logotipo do calendário",
    "select_team_member" : "selecionar Grupo Membros",
    "select_single_team_member" : "Selecionar membro da equipe",
    "eg_outbound_reach" : "(por exemplo) Alcance Enviadas",
    "description" : "Descrição",
    "amount" : "Valor",
    "description_placeholder" : "Escreva a descrição",
    "meeting_duration" : "Duração da reunião",
    "meeting_location" : "Local da reunião",
    "seats_per_class" : "Assentos por Aula",
    "group" : "Grupo",
    "custom_url" : "URL Personalizado",
    "meeting_invite_title" : "Conferência convites Título",
    "event_color" : "Cor do Evento",
    "availability_type" : "Disponibilidade digital",
    "new_calendar" : "novo Calendário",
    "add_description" : "Adicionar descrição",
    "remove_description" : "Descrição do extrato",
    "booking_availability" : "Disponibilidade de agendamento",
    "slug_tooltip" : "Personalizar a URLdo agendamento do Widget",
    "meeting_location_tooltip" : "Links de conferência são comparecidos in ocorrências do calendário como a 'Conferência Local' e Habilitar Você para incluir coisas Links de Zoom do Curtir para o Evento.",
    "advanced_settings" : "Configurações avançadas",
    "show_more_schedule" : "Mostrar mais",
    "show_more_helper_text" : "Para personalizar ainda mais seu horário de funcionamento, acesse as configurações avançadas",
    "reschedule_preference" : "Preferência de Reagendar",
    "reschedule_preference_subtext" : "Se um {contactLabel} reagendar um compromisso:",
    "reassign_through_round_robin" : "Reatribuir a Via Rodízio",
    "keep_same_assinged_user" : "Manter o mesmo Compromisso Proprietário",
    "new_appointment_preference" : "Preferência de novo Compromisso",
    "new_appointment_preference_text" : "Sempre agendar com o usuário atribuído do {contactLabel}",
    "new_appointment_preference_subtext" : "Agende novos compromissos com o usuário atribuído do {contactLabel}, em vez de usar o agendamento em rodízio.",
    "cancel" : "Cancelar",
    "confirm" : "Confirmar",
    "service_calendar_name" : "Nome do serviço",
    "service_logo" : "Logotipo do serviço",
    "service_select_team_member" : "Selecionar equipe Membros",
    "service_duration" : "Duração do serviço",
    "appointment_invite_title" : "Título de convite do Compromisso",
    "payment_placeholder" : "Insira uma descrição que será exibida para o usuário, informações sobre o pagamento",
    "deposit_amount" : "Valor do pagamento",
    "collect_deposit_amount" : "Aceitar pagamento incompleto",
    "percentage" : "Porcentagem",
    "total_amount" : "Valor Total",
    "enter_meeting_location" : "Digite o local da reunião",
    "accept_payments" : "Aceitar pagamentos",
    "aria" : {
      "should_accept_payment" : "Deve aceitar pagamento"
    },
    "calendar_name_tooltip" : "Nome do calendário a ser exibido Ativado o Widget de agendamento",
    "booking_availability_tooltip" : "Coleção os dias e a hora durante os quais as agendamentos podem ser feitas. Este é seu padrão semanalmente Empresa hora Comparar com Usuário Quando selecionando uma janela de tempo",
    "select_team_member_tooltip" : "selecionar o Grupo Membros(s) que levarão esta Conferência",
    "seats_per_class_tooltip" : "Coleção o número máximo de Membros permitidos para Agendar esta Aula. Depois que todos os Assentos forem preenchidos, a janela de tempo não ficará mais disponível para reserva",
    "meeting_color" : "Conferência Cor",
    "meeting_duration_tooltip" : "Este Fixo o comprimento da sua conferência, determinando quanto tempo ela será último"
  },
  "calendar_advanced" : {
    "general" : {
      "quick_tip" : "Gorjeta rápida",
      "timezone_change_tip" : "As zona de dados podem ser Dinâmico a qualquer momento nas configurações da zona de dados",
      "save" : "Arquivar",
      "close" : "Fechar",
      "meeting_details" : "Conferência Detalhes",
      "availability" : "Disponibilidade",
      "forms_and_payment" : "Formulários e pagamento",
      "notifications_and_additional_options" : "Lembrete e opções adicionais",
      "connections" : "Conexões",
      "customizations" : "Personalizações",
      "create" : "Criar",
      "edit" : "Editar",
      "equipments" : "Salas e Equipamentos",
      "service_details" : "Detalhes do serviço",
      "saving_changes" : "Apenas um minuto — Salvando o Dinâmico mais recente...",
      "calendar_id": "ID do calendário",
      "saveCalendarSuccess": "Calendário salvo com sucesso"
    },
    "meeting_details" : {
      "meeting_location" : "Conferência encontrada",
      "enter_meeting_location" : "Digite a conferência localização",
      "click_to_upload" : "clicar para Carregar",
      "square" : "Quadrado",
      "circle" : "Círculo",
      "remove_logo" : "Extrair logotipotipo",
      "meeting_invite_title_tooltip" : "Este é o título para a Conferência de calendário que comparou in suas Exibição de Agendamentos em lista, Calendário Visualizar e Calendários externos",
      "event_color_tooltip" : "selecionar um Cor para esta reserva Evento. As cores são conectadas com ocorrências in Agenda Google .",
      "enter_a_name" : "Digite um nome",
      "enter_an_event_title" : "Insira um título de evento",
      "high_priority" : "Prioridade máxima",
      "medium_priority" : "Prioridade do Médio",
      "low_priority" : "Prioridade mínima",
      "priority" : "Prioridade",
      "custom" : "Personalizado(a)",
      "zoom_not_added" : "O usuário ainda não conectará sua conta Zoom",
      "opt_avail" : "Otimizar para disponibilidade",
      "opt_equal" : "Otimizar para entrega igual",
      "team_members" : "selecionar Grupo Membros",
      "team_members_location" : "Selecionar Grupo Membros e Atribuir Conferência Localização",
      "team_member" : "selecionar Grupo Membros",
      "team_member_location" : "Selecionar Grupo Membros e Atribuir Conferência Localização",
      "meeting_location_required" : "Conferência de localização é obrigatório",
      "meeting_details" : "Conferência Detalhes",
      "meeting_details_description" : "Essas são os detalhes que serão comparecidos in Lista Página do calendário.",
      "or_drag_and_drop" : "Ou Arrastar e soltar",
      "service_details" : "Detalhes do serviço",
      "team_member_disabled_recurring_tooltip" : "Reuniões recorrentes Habilitar apenas um Grupo Membros. Para incluir vários Membros do Grupo, Desabilitar Reuniões recorrentes.",
      "team_member_disabled_class_booking_tooltip" : "Somente um Grupo Membros pode ser adicionado a um Aula Calendário de serviços",
      "advanced_settings" : "Configurações avançadas",
      "enable_contact_assigned_to_setting" : "Para habilitar esta configuração, o formulário deve ser o primeiro in Widget Ordenar. Reagendar o Widget Ordenar De a aba Formulários e pagamento.",
      "reschedule_preference_setting_tooltip" : "Selecionar a quem o compromisso deve ser atribuído quando um {contactLabel} for reagendado a partir do widget de agendamento.",
      "appointment_preference_tooltip" : "Selecionar se novos compromissos devem ser sempre agendados com o usuário atribuído do {contactLabel}. Se um {contactLabel} tiver um Usuário atribuído, esse Usuário terá Preferência; caso contrário, será uma atribuição em Rodízio. Dica: desabilitar \"Habilitar seleção de equipe\" para evitar que os agendadores alterem o membro da equipe no widget de agendamento.",
      "add_location" : "Adicionar Localização",
      "multiple_locations_neo" : "Vários endereços de conferência são compatíveis apenas com o Neo Widget.",
      "make_owner" : "Criar Proprietário",
      "only_one_team_member" : "Somente um Grupo Membros é permitido Quando vários endereços são adicionados.",
      "ask_the_booker_error_message" : "Pergunte ao Agendador Localização já existe",
      "enter_location" : "Insira o Valor da Localização",
      "enter_display_label" : "Insira o rótulo de Exibição",
      "add_display_label" : "Adicionar rótulo de Exibição",
      "multiple_location_support_message" : "Vários endereços de conferência são compatíveis apenas com o Neo Widget.",
      "only_one_team_member_personal_calendar" : "Somente um Grupo Membros é permitido para reserva pessoal ",
      "ms_teams_not_added" : "O usuário ainda não conectado seu Microsoft Grupo Conta",
      "enable_new_appt_preference" : "Habilitar Preferência de novo Compromisso",
      "enable_new_appt_preference_desc" : "Ao habilitar &quot;<b>Sempre agendar com o usuário atribuído do {contactLabel}</b>&quot; o <b>Formulário</b> será sempre definido como a primeira etapa na ordem do widget.",
      "location_exists_toast" : "Conferência de localização já adicionada",
      "not_supported_with_multiple_team_members" : "Não compatível com vários Grupo Membros",
      "not_supported_personal_calendar" : "Não compatível in o calendário pessoal",
      "not_supported_class_booking" : "Não compatível in a Aula Calendário de serviços",
      "not_supported_collective_booking" : "Não compatível in o calendário COLETIVO",
      "not_supported_service_booking" : "Não compatível in o Calendário de serviços",
      "not_supported_round_robin" : "Não compatível in o calendário do Rodízio",
      "not_supported_event" : "Não compatível in o calendário do Evento",
      "calendar_logo_tooltip" : "selecionar um logotipo para ser comparecido Ativado o Widget de agendamento",
      "calendar_name_tooltip" : "Nome do calendário a ser exibido Ativado o Widget de agendamento",
      "description_tooltip" : "Descrever o que é o calendário sobre, a ser exibido Ativado o Widget de agendamento",
      "group_tooltip" : "Você pode atribuir este calendário a um Grupo ( Se Criado). O usuário Acesso o Link do grupo pode pesquisar e Agendar de todos calendários in grupo",
      "custom_url_tooltip" : "Personalizar a URLdo agendamento do Widget",
      "meeting_color_tooltip" : "selecionar um Cor para esta reserva Evento. Cores obter sincronização para eventos in agenda Google",
      "add_display_label_tooltip" : "Para ocultar a localização, caso várias opções estejam disponíveis",
      "meeting_location_tooltip" : "selecionar como Ou para onde a Conferência levará a Localização",
      "team_members_location_tooltip" : "selecionar o Grupo Membros que levarão esta Conferência",
      "meeting_distribution" : "Conferência entrega",
      "meeting_distribution_tooltip" : "selecionar como os Agendamentos são distribuídas em seu Selecionado Grupo Membros - com base Ativado Disponibilidade ou igual entrega",
      "opt_avail_tooltip" : "Atribua Reuniões ao Grupo Membros que está disponível no Selecionado Data, independentemente das reservações anteriores. Máxima a uso do intervalo aberto e reservando frequência de sucesso",
      "opt_equal_tooltip" : "Reuniões públicas Igualmente entre todos o Grupo Membros Via rastreamento de agendamentos anteriores. Prioriza a equência sobre a Disponibilidade",
      "priority_tooltip" : "Coleção o Plano de preferência para atribuir conferências Quando vários Grupos Membros estão disponíveis. Os Membros de maior Prioridade serão consideradas primeiro para reservas, Seguir Via Médio e Membros de menor Prioridade",
      "contact_routing_preference" : "Preferência de roteamento de Contato",
      "contact_routing_preference_tooltip" : "Defina como {contactsLabel} novos e recorrentes são atribuídos aos membros do grupo — por rodízio ou pelo proprietário original",
      "team_members_location_owner_tooltip" : "O PRINCIPAL Usuário que é proprietário da Conferência e que oferece a conferência final Localização",
      "owner" : "Proprietário",
      "upload_from_system" : "Carregar do sistema",
      "choose_from_media_storage" : "Selecionar do armazenamento de mídia",
      "only_one_team_member_allowed" : "Somente um membro da equipe é permitido",
      "at_least_two_team_members_required" : "Pelo menos dois membros da equipe são necessários",
      "at_least_one_team_member_required" : "Pelo menos um membro da equipe é necessário"
    },
    "availability" : {
      "my_availability" : "Minha disponibilidade",
      "set_availability" : "Coleção sua disponibilidade para o calendário aqui.",
      "standard" : "Padrão",
      "custom" : "Personalizado(a)",
      "to" : "Para",
      "copy_to_all" : "Copiar para todos",
      "add_time" : "Adicionar dados",
      "recurring_meeting" : "Conferência Recorrente",
      "recurring_info" : "Somente um Usuário por calendário para reserva Recorrente",
      "repeat" : "Repetição",
      "times_to_repeat" : "vezes para Repetição",
      "slots_unavailable" : "Se os intervalos não estiverem disponíveis?",
      "overlap_status" : "Status do Compromisso para intervalos sobrepostas ",
      "meeting_interval" : "Intervalo da reunião",
      "meeting_duration" : "Duração da reunião",
      "minimum_scheduling" : "Mínimo Programar AVSO",
      "date_range" : "Escopos de dados",
      "maximum_bookings_per_day" : "Máximo de reservações por dia",
      "maximum_bookings_per_slot" : "Máximo de agendamentos por intervalo",
      "maximum_bookings_per_slot_per_user" : "Máximo de agendamentos por intervalo (por usuário)",
      "seats_per_class" : "Assentos por Aula",
      "pre_buffer_time" : "Tempo de buffer prévio",
      "post_buffer_time" : "Tempo de buffer posterior",
      "pre_buffer_tooltip" : "O pré- buffer são dados adicionais que podem ser adicionados antes de um compromisso, Habilitar para dados extras para obter o Pronto",
      "post_buffer_tooltip" : "O buffer posterior é de dados adicionais que podem ser adicionados Depois de um compromisso, Habilitar para dados extras para terminar",
      "buffer_time" : "Dados de BUFFER",
      "daily" : "Diário",
      "weekly" : "Semanalmente",
      "monthly" : "Mensalmente",
      "skip_booking" : "Ignorar reserva de intervalos não disponíveis",
      "continue_booking" : "Continuar reserva",
      "book_next_available" : "Agendar Próximo intervalo disponível",
      "confirmed" : "Confirmado",
      "unconfirmed" : "Não confirmado",
      "enter_valid_hours" : "Insira uma hora aberta válida",
      "enter_valid_avail" : "Insira uma disponibilidade personalizada válida",
      "availability_type_tooltip" : "selecionar o padrão Disponibilidade para agendamentos mensalmente oferecido semanalmente. Selecionar personalizado para agendamentos disponíveis apenas em datas específicas ativadas.",
      "meeting_interval_tooltip" : "A Conferência Segundos reflete a quantidade de dados entre intervalos de reserva que serão comparecidos in calendário. Para um evento mínimo de 30 que deve estar disponível na Principal de todos a hora, os Segundos seriam de 1 hora. Para um evento mínimo de 30 que deve estar disponível todos 30 minutos, os Segundos seriam de 30 minutos.",
      "date_range_tooltip" : "ocorrências podem ser Programadas ao longo dos Próximos dias.",
      "maximum_bookings_per_day_tooltip" : "Número máximo de conferências permitidas por dia ativado este calendário",
      "maximum_bookings_per_slot_tooltip" : "Máximo número de compromisso permitido por intervalo para o Usuário ( Se o número de compromisso exceder para o intervalo fornecido para o Usuário, Então ou ou alterna para o Próximo Usuário in fila do Rodízio Ou Marca d'água o intervalo não disponível para o Oportunidade para Agendar).",
      "add_days" : "Adicionar dias",
      "month_on_day" : "Mensalmente ativado dia",
      "month_on_last_day" : "Mensalmente Ativado último",
      "day" : "Dia",
      "week" : "Semana",
      "month" : "Mês",
      "mins" : "Minutos",
      "hours" : "Horas",
      "days" : "Dias",
      "weeks" : "Semanas",
      "months" : "Meses",
      "meeting_interval_error" : "A conferência segundos deve estar entre 5 minutos e 12 horas",
      "meeting_duration_error" : "A duração da reunião deve estar entre 1 mínima e 12 horas",
      "buffer_time_error" : "Os dados de BUFFER devem ser menor que 12 horas",
      "appointment_interval" : "Compromisso Segundos",
      "appointment_duration" : "Duração do Compromisso",
      "maximum_appointments_per_day" : "Máximo compromisso por dia",
      "subTitle" : "selecionar os dados para a coleção específicas da hora",
      "heading_1" : "Horários disponíveis Semanalmente",
      "scheduling_availability_heading" : "Disponibilidade de Reserva",
      "tooltip_1" : "Coleção sua programação de disponibilidade semanal. Essas são as suas horas padrão que serão aplicadas de modo gradual Ativado a semanalmente",
      "heading_2" : "Quando Você está disponível?",
      "unavailable_label" : "Não disponível",
      "tooltip_2" : "Modifique sua programação para datas específicas. Substitui sua mensalmente semanalmente hora Via marcando a Disponibilidade ou a não disponibilidade para datas selecionadas.",
      "date_specific_level" : "Adicionar datas específicas de hora",
      "specific_hours_button" : "Horários específicos da Data",
      "specific_hours_description" : "Substitua sua disponibilidade em datas específicas quando seu horário difere do horário semanal normal.",
      "overlap_error" : "Intervalos de dados não podem SOBREPOSIÇÃO",
      "apply" : "Aplicar",
      "copy_times_to" : "Copiar vezes para",
      "no_date_specific_heading" : "Nenhum dado específico adicionado",
      "no_date_specific_description" : "Você pode incluir/extrair dados específicos e dados para sua disponibilidade",
      "recurring_disabled_conditions_tooltip" : "Reuniões recorrentes estão desabilitadas. Para gatilhos, certifique-se de que o calendário tenha apenas um Grupo Membros e não tenha hora específicas ou pagamento incompleto adicionado.",
      "date_specific_hours_disabled_conditions_tooltip" : "Para incluir uma hora com data específicas, certifique-se de que as Reuniões recorrentes estejam desabilitadas.",
      "recurring_disable_event_calendar_conditions" : "Reuniões recorrentes estão desabilitadas. Para ativá-los, certifique-se de que nenhum pagamento específico ou incompleto seja adicionado.",
      "service_duration" : "Duração do serviço",
      "service_interval" : "Segundos de serviço",
      "service_interval_tooltip" : "A Conferência Segundos Fixo com que frequência aparece intervalos de reserva Ativado o calendário. Para o Modelo, para um evento de 30 minutos, um Segundos de 1 hora significa que os intervalos aparecerão todas as horas. Um Segundos de 30 minutos significa intervalos que aparecerão todos 30 minutos.",
      "service_duration_tooltip" : "Essa fixa o comprimento do seu compromisso, determinando quanto tempo ele será o último.",
      "minimum_scheduling_tooltip" : "Este Fixo, os dados mínimos Obrigatório para agendar um compromisso Via o Widget de calendário . Para Modelo, Se Coleção a 4 horas, o Compromisso não pode ser reservado a 4 horas de suas datas de início; as agendamentos devem ser feitas com pelo menos 4 horas in antecedência.",
      "look_busy_title" : "Parecer ocupado",
      "look_busy_helper_text" : "Ocultar a porcentagem de seus intervalos de compromisso disponíveis Ativado o agendamento do Widget para aparecer mais ocupado e in grande demanda",
      "look_busy_percentage_description" : "Ocultar o número de intervalos disponíveis Via x%",
      "maximum_bookings_per_slot_tooltip_personal" : "Limite de quantas conferências podem ser programadas para a mesma janela de tempo",
      "enable_recurring_title" : "Habilitar conferência recorrente",
      "enable_recurring_desc" : "Ativar <b>compromissos recorrentes</b> desabilitará automaticamente as configurações posteriores, pois elas não podem existir:",
      "date_specific_hours" : "todos <b>as horas com datas específicas</b> serão Apagado.",
      "multiple_team_members" : "<b>Vários Membros do Grupo</b> serão Inscrição concedido - somente um Grupo Membros pode permanecer in calendário.",
      "partial_payments" : "<b>Pagamentos incompletos</b> serão Desabilitados, e o valor de Concluído será cobrado.",
      "select_team_member_to_keep" : "selecionar um Grupo Membros para manter in calendário:",
      "select_team_member" : "selecionar Grupo Membros",
      "partial_payments_disabled" : "Como os pagamentos incompletos serão desabilitados, como Você Curtir para cobrar o valor completo do Recorrente Compromisso?",
      "enable_date_specific_hours" : "Habilitar horários específicos para Data",
      "enable_date_specific_hours_desc" : "Ativar <b>horas com data específicas</b> desabilitará automaticamente a configuração posterior, pois elas não podem existir:",
      "recurring_meetings_disabled" : "<b>Reuniões Recorrentes serão desabilitadas</b>, {contactsLabel} só poderão agendar compromissos individuais com base nas datas disponíveis que você configurar.",
      "payment_preference" : "Preferência de pagamento:",
      "team_members_in_this_calendar" : "Grupo Membros in calendário",
      "other_team_members" : "Outro Grupo Membros (Não adicionado a este calendário)",
      "select_team_member_tooltip" : "selecionar o Grupo Membros(s) que levarão esta Conferência",
      "meeting_duration_tooltip" : "Este Fixo o comprimento da sua conferência, determinando quanto tempo ela será último",
      "date_specific_hours_tooltip" : "Modifique sua programação para datas específicas. Substitui sua mensalmente semanalmente hora Via seleção",
      "recurring_meeting_tooltip" : "Habilitar Reuniões para Repetição várias vezes ao longo de uma semana",
      "repeat_frequency_tooltip" : "selecione a frequência deste evento recorrente",
      "time_to_repeat_tooltip" : "Coleção o número Total de repetição",
      "slots_unavailable_tooltip" : "selecionar o que deve ocorrer Se um ou mais intervalos de dados in uma reserva Recorrente já estão reservados",
      "skip_booking_tooltip" : "Somente os intervalos disponíveis serão reservados. Todas as datas não disponíveis in serie Recorrente serão ignoradas",
      "force_book" : "Agendar de valor",
      "force_booking_tooltip" : "todos os intervalos serão reservados, Uniforme Se Lá é um Conflito. Use com Atenção para evitar Agendamentos duplos",
      "book_next_available_tooltip" : "Se um intervalo selecionado não está disponível, Agendar o Próximo intervalo disponível Ativado a mesma programação recorrente (por exemplo, Próximo segunda-feira Se Semanalmente)",
      "slot_interval_tooltip" : "Coleção a falha entre as vezes de início de intervalos seguidos disponíveis. Para o Modelo, Se sua conferência A duração é de 30 minutos e Você Coleção os Segundos a 60 minutos, um usuário pode Agendar às 9:00 AM, Também 10:00 AM, e portanto Ativado - Uniforme, mas todos a Conferência duração de apenas 30 minutos",
      "minimum_scheduling_notice_tooltip" : "Obrigatório Usuário para compromissos da agenda com pelo menos esta quantidade de dados in antecedência",
      "date_range_preferences_tooltip" : "Coleção até que data de agendamentos futuros podem ser feitas Dados de hoje",
      "maximum_bookings_per_slot_preferences_tooltip" : "Limite de quantas conferências podem ser programadas para a mesma janela de tempo",
      "maximum_bookings_per_slot_per_user_preferences_tooltip" : "Limite de quantas Reuniões podem ser Programadas para a mesma janela de tempo (por Usuário)",
      "pre_buffer_time_tooltip" : "Dados para bloquear Antes de todos Conferência, Habilitar para dados extras para se preparar",
      "post_buffer_time_tooltip" : "Dados para bloquear Depois todos Conferência, Habilitar para dados extras para finalização",
      "seats_per_class_tooltip" : "Coleção o número máximo de Membros permitidos para Agendar esta Aula. Depois que todos os Assentos forem preenchidos, a janela de tempo não ficará mais disponível para reserva",
      "maximum_bookings_per_slot_per_user_tooltip" : "Limite de quantas Reuniões podem ser Programadas para a mesma janela de tempo (por Usuário)",
      "repeat_frequency" : "Frequência de Repetição",
      "slot_interval" : "Segundos de intervalo",
      "skip_booking_helper_text" : "Somente os intervalos disponíveis serão reservados. Todas as datas não disponíveis in serie Recorrente serão ignoradas",
      "force_book_helper_text" : "todos os intervalos serão reservados, Uniforme Se Lá é um Conflito. Use com Atenção para evitar Agendamentos duplos",
      "book_next_available_helper_text" : "Se um intervalo selecionado não estiver disponível, Agendar o Próximo intervalo disponível Ativado a mesma programação recorrente (por exemplo, Próximo segunda-feira Se Semanalmente).",
      "bulk_edit" : "Edição em massa",
      "select_users" : "Selecionar usuários",
      "select_all" : "Selecionar todos",
      "times_to_repeat_tooltip" : "Defina o número total de recorrências"
    },
    "forms_payment" : {
      "forms" : "Formulários",
      "forms_sub" : "Coleção pós-programada Formulários Configurações.",
      "select_form" : "selecionar formulário",
      "enable_same_user_assignment" : "Atribuir Amigos aos seus respectivos calendários Grupo Membros todos Data um compromisso está reservado",
      "sticky_contacts" : "Pré-preenchimento de Campos ( Persistente Amigos )",
      "confirmation_page" : "Página de confirmação",
      "default" : "Padrão",
      "redirect_url" : "URL de redirecionamento",
      "thank_you" : "Obrigado Mensagem",
      "enter_url" : "Insira o URL",
      "amount_tab_hidden_label" : "Placeholder da guia Valor",
      "percentage_tab_hidden_label" : "Placeholder da guia Porcentagem",
      "pixel_id" : "Meta Id do pixel (Opcional)",
      "auto_confirm" : "Confirmar automaticamente novo compromissos de calendário",
      "configure_payment" : "Configuração de pagamentos Opções",
      "accept_payments" : "Aceitar pagamentos",
      "test" : "Testar",
      "live" : "Ao vivo",
      "enable_guests" : "Adicionar convidados",
      "add_guest_tooltip" : "Adicionar Convidado habilitará seu Convidado para Incluir vários participantes ao mesmo compromisso",
      "add_guest_custom_form_tooltip" : "Habilitar esta opção carregará um e-mail gerado pelo sistema para os convidados com um Link para o formulário personalizado assim que o compromisso for confirmado. Para evitar a duplicação Gmail, certifique-se de que um e-mail de confirmação separado ainda não seja Configuração para convidados. (Verifique isso in aba Lembrete > Confirmation Notificação)",
      "add_guest_same_form_check" : "Carregar o mesmo formulário para coletar detalhes Via e-mail para todos os convidados",
      "payment_tooltip" : "O pagamento só seria considerada para o PRINCIPAL Convidado e não para os convidados.",
      "default_form" : "Padrão (nome, último nome, e-mail, Telefone, Notas)",
      "select_form_tooltip" : "Se Você seria curto para coletar mais detalhes para coletar mais detalhes do que o padrão Nome, último Nome, E - mail e Telefone De esses que Agendar Ativado este calendário, Criar um formulário personalizado in Sites > Formulários > Construtor .",
      "confirmation_page_tooltip" : "Depois que alguém faz uma reserva, Você pode selecionar para exibir uma Mensagem personalizada ativada na mesma página (Padrão) ou redirecionar para uma página de sua escolha (Redirecionamento).",
      "add_guest_collect_email" : "Nome e e-mail",
      "add_guest_count_only" : "Contagem apenas",
      "custom_email_notification" : "Carregar formulário personalizado para convidados",
      "consent_label" : "Caixa de seleção de Consentimento",
      "consent_input_placeholder" : "Adicionar consentimento Corpo",
      "same_user_assignment_tooltip" : "Para habilitar esta configuração, o formulário deve ser primeiro ativado o Widget. Reagendar o Widget para Status do formulário primeiro para esta configuração de gatilho.",
      "consent_tooltip" : "Alterne esta opção para permitir a obtenção de consentimento do {contactsLabel} quando eles fornecerem seu número de telefone durante o fluxo de trabalho de agendamento de compromissos.",
      "stripe_error" : "Até dois decimals ( Modelo: 25,99)",
      "auto_confirm_service" : "Confirmar automaticamente novo compromisso",
      "service_form_message" : "Se um contato está agendando vários serviços, eles verá apenas o formulário padrão in menu de serviços",
      "deposit_amount_error" : "O valor do pagamento deve ser menor que o valor Total .",
      "deposit_percentage_error" : "A porcentagem do pagamento deve ser menor que 100\".",
      "partial_payment_tooltip" : "Habilitar pagamentos incompletos para cobrar o valor do pagamento De Clientes durante o Pipeline de reserva de compromisso",
      "partial_payment_enable_error" : "O valor Total inserida deve ser maior que 0 para Habilitar pagamentos incompletos.",
      "payment_disable_text_integration" : "Integre um provedor de pagamento em Pagamentos > Integrações para começar a aceitar pagamentos",
      "payment_disable_text_recurring" : "Aceitar a opção de pagamento não está disponível para conferências Recorrente. Desabilitar Recorrente para pagamentos do Habilitar.",
      "date_and_time_selector" : "Dados e seletor de dados",
      "form_selector" : "Formulário",
      "order_step" : "Etapa",
      "widget_order_label" : "Ordenar de Widget",
      "widget_order_tool_tip" : "Reagendar o 'Dados e seletor de dados' e o ' Formulário' Ordenar Ativado o Widget de calendário . Arrastar e reordenar por sua Preferência.",
      "widget_re_order_tooltip" : "A reordenação está disponível apenas com o estilo Neo Widget . Alterne para Neo para reordenar Habilitar.",
      "widget_re_order_disabled_tooltip" : "Para reorganizar a ordem do widget, desative a opção \"Nova preferência de compromisso (sempre agendar com o usuário atribuído do {contactLabel})\" em Informações da conferência > Membros do grupo > Seção Configurações avançadas.",
      "payment_description_error" : "Caractere máximo Limite de intervalos de 1000 atingido",
      "widget_multiple_location_disabled_tooltip" : "O Widget Clássico não é compatível com vários Endereços de Conferência. Extraa qualquer endereço adicional para usar o WidgetClássico",
      "recurring_payment_label" : "Pagamento recorrente de compromisso",
      "enable_payments_for_guests" : "Habilitar pagamentos para convidados",
      "guest_payment_description" : "Como Você tem habilitado a opção \"Adição de convidados\", Você também pode selecionar a cobrança por Convidado Quando de reserva.",
      "charge_per_attendee" : "cobrança por Convidado",
      "charge_per_attendee_description" : "Multiplicar o valor Total Via o número de participantes (incluindo convidados) Ao cobrar o pagamento durante a reserva.",
      "click_confirm_description" : "Clique em salvar para aplicar as alterações.",
      "multiply_amount_guests" : "Cobrar pagamento para todos os participantes",
      "multiply_amount_guests_description" : "Quando habilitado, o valor a ser cobrado durante a reserva será duplicado Via o número Total de participantes, incluindo convidados",
      "first_appointment_only" : "cobrança apenas para o primeiro compromisso",
      "all_appointments" : "cobrança para todos Compromisso inicial",
      "no_payment_provider_connected" : "Nenhum pagamento Provedor conectado",
      "no_default_payment_provider" : "Nenhum pagamento Provedor conectado",
      "provider_not_supported" : "O provedor de pagamento padrão não é compatível",
      "manage_payment_provider" : "Gerenciar provedores de pagamento",
      "supported_providers" : "Provedores compatíveis",
      "paypal_razorpay_helper_text" : "Payments will be processed through Razorpay only, as PayPal isn’t supported with custom providers",
      "rearrange_widget_order" : "Reagendar Widget Ordenar",
      "change_form_order" : "Dinâmico do formulário para a segunda etapa in Widget Ordenar desabilitará a configuração posterior:",
      "change_form_order_desc" : "<b>Nova preferência de compromisso (sempre agende com o usuário atribuído do {contactLabel})</b> será desabilitada. Isso significa que os compromissos podem ser agendados com qualquer membro do grupo disponível, em vez de serem limitados ao usuário atribuído do {contactLabel}.",
      "enable_mandatory_guest" : "Criar adicionando pelo menos um Convidado Obrigatório. O Convidado Campos será pré-aberto e deve ser preenchido antes da reserva.",
      "enable_mandatory_guest_count" : "Obter o Obrigatório Convidado Contagem Ativado o Widget de agendamento",
      "require_guest_for_booking" : "Convidados obrigatórios para reserva",
      "sticky_contacts_tooltip" : "Campos de preenchimento automático para {contactsLabel} conhecidos.",
      "auto_confirm_tooltip" : "Marca d'água automaticamente novas Reuniões como Confirmado sem exigir aprovação Manual . Desabilitar este Se Você quiser para a avaliação e confirmar todos a reserva manualmente antes de ser programado",
      "confirm_tooltip" : "Depois que alguém faz uma reserva, Você pode selecionar para exibir uma Mensagem personalizada ativada na mesma página (Padrão) ou redirecionar para uma página de sua escolha (URL de redirecionamento)",
      "facebook_pixel_id_tooltip" : "",
      "accept_payments_tooltip" : "Habilitar Coleção de pagamentos durante as reservas",
      "total_amount_tooltip" : "Coleção a cobrança Total para a Conferência",
      "deposit_amount_tooltip" : "Valor a ser cobrado no momento da reserva como um pagamento",
      "multiply_amount_guests_all_guests" : "Cobrar pagamento para todos os participantes, incluindo convidados",
      "multiply_amount_guests_all_guests_tooltip" : "Quando habilitado, o valor a ser cobrado durante a reserva será duplicado Via o número Total de participantes, incluindo convidados",
      "payment_description" : "Descrição do pagamento",
      "payment_description_tooltip" : "Opcionalmente, inclua quaisquer detalhes útil sobre o pagamento",
      "test_mode_warning" : "Modo de teste Dinâmico - nenhuma venda real será processada.",
      "pixel_id_tooltip" : "Carregar Widget de agendamento Atividade Curtir Visualizações, cliques e envios para Meta Via seu Id do pixel",
      "forms_description" : "Configuração de campos e fluxo de sua reserva Formulário",
      "payment_mode" : "Modo de pagamento",
      "payment_mode_tooltip" : "Alterne entre o modo de teste e o modo Ao vivo para pagamentos. in modo de teste, nenhum faturamento real é feito — use-o para estimar a reserva e o Pipeline de pagamento . Mude para o modo Ao vivo para aceitar pagamentos atuais De Clientes.",
      "enable_coupon" : "Ativar códigos de cupom",
      "enable_coupon_tooltip" : "Habilitar que os Clientes salvem Códigos de cupom durante a reserva. Para garantir que funcionem, crie primeiro Códigos de cupom válidos em Pagamentos > Códigos de cupom"
    },
    "notifications" : {
      "notifications" : "Lembrete e opções adicionais",
      "notifications_sub" : "Configuração Notificação e opções adicionais",
      "edit" : "Editar",
      "created_on" : "Criado em",
      "updated_on" : "Atualizado(a) em",
      "delivered" : "Entregue",
      "not_available" : "N/A",
      "select_notification_type" : "selecione o dígito de notificação",
      "notification_person" : "Quem deve Herdar esta notificação?",
      "contact" : "{contactLabel}",
      "guest" : "Convidado",
      "assigned_user" : "Usuário atribuído",
      "emails" : "Gmail",
      "alert_email_address" : "Endereço de e-mail de Alerta",
      "ack_email" : "E-mail de Reconhecimento",
      "send_google_invites" : "Habilitar a Agenda Google para carregar o convite ou atualizar Gmail para os participantes.",
      "send_google_outlook_invites" : "Permitir que o Google / Calendário do Outlook / Calendário do iCloud envie convites e e-mails de atualização para os participantes.",
      "assign_user_to_contact" : "Atribua {contactsLabel} aos respectivos membros do grupo de calendário cada vez que um compromisso for agendado",
      "skip_assigning_user_to_contact" : "Pule a atribuição de {contactLabel} se o {contactLabel} já tiver um usuário atribuído",
      "assigned_staff" : "Equipe atribuída",
      "additional_emails" : "Gmailadicional",
      "assign_user_to_staff" : "Atribua {contactsLabel} aos respectivos membros da equipe de serviço cada vez que um compromisso for agendado",
      "allow_cancellation" : " Permitir cancelamento de reunião",
      "allow_reschedule" : "Permitir o reagendamento da reunião",
      "allow_cancellation_tooltip" : "Quando Habilitado, um Link de cancelamento será adicionado à Seção de observações adicionais e incluído in convite do calendário. Este Link será o Vencido como configurado antes dos dados da conferência, evitar que o Agendador De cancel a conferência.",
      "allow_reschedule_tooltip" : " Quando Habilitado, um Link de reprogramação será adicionado à Seção de observações adicionais e incluído in convite do calendário. Este Link será o Vencido como configurado antes dos dados de início da conferência, evitar que o Agendador De reagendar a conferência.",
      "cancellation_link_expiry" : "O link de cancelamento irá expirar",
      "reschedule_link_expiry" : "O link de reagendamento vai expirar",
      "before_meeting" : "Antes da conferência",
      "cancellation_and_reschedule_policy" : "Condições de cancelamento e Reagendar :",
      "meeting_invite_notes" : "Notas de convite da conferência",
      "meeting_invite_notes_tooltip" : "Adicionar observações que aparecerão in calendário são convidados enviados para Clientes. Essas notas serão a sincronização com os Calendários externos in Conferência Descrição"
    },
    "connections" : {
      "connections_heading" : "Calendários externos Sincronização",
      "connections_sub" : "Sincronização ocorrências com Calendários externos",
      "link_to_calendar" : "Link para o calendário",
      "sync_option" : "Opções de Sincronização",
      "execute_automation" : "Executar automação",
      "fire_workflow" : "Disparadores de gatilho de fluxo de trabalho para eventos agendados via sincronização bidirecional",
      "reserve_with_google" : "Agendar com Google (A ser obsoleta)",
      "reserve_with_google_setup" : "Visualizar Instruções de configuração",
      "reserve_with_google_configure" : "Configuração",
      "change" : "Alterar",
      "rwg_deprecation_notice" : "Google <strong>descontinuamos o Agendar com Google (RWG)</strong>,conhecido como <strong>Local Serviços Anúncios</strong>. não há mais suporte para novas conexões. Para continuar agendamentos de recebimento Via Google, use <strong>o Agendamento orgânico do Google</strong> .",
      "rwg_category" : "Categoria",
      "rwg_service_type" : "Serviço",
      "connect_lsa" : "Conecte-se com seus Serviços Conta de anúncios locais",
      "reserve_error" : "O agora Agendar com Google é compatível com apenas para \"Empresa Serviços\", \"Real Estate\", \"LeGal Serviços\" (provedores de serviços locais) Empresa nicho in EUA.",
      "one_way" : "Único",
      "two_way" : "Duas via",
      "smart" : "Inteligente",
      "confirm_remove" : "Tem certeza de que deseja Extrair a Agenda Google ?",
      "read_only_access" : "Você não tem acesso de gravação a este calendário. Selecione um calendário diferente.",
      "reserve_with_google_desc" : "Este serviço de calendário será listado in Agendar com apenas Google Ativado Integração com êxito.",
      "check_integration" : "Marca de verificação seu Status de integração",
      "setup_external" : "Configuração de seus calendários externos",
      "reserve_price_decimal_error" : "Não há suporte para preço decimal",
      "reserve_price_max_error" : "Preço compatível com menos de 1000",
      "link_to_calendar_tooltip" : "selecione o calendário com o qual Você deseja sincronizar este calendário",
      "one_way_sync" : "Unidirecional",
      "default_one_way" : "Sincronização padrão (sincronização unidirecional)",
      "one_way_sync_desc" : "Os eventos do calendário vinculado são sincronizados como intervalos bloqueados, e nenhum contato é criado para os convidados.",
      "two_way_sync" : "Sincronização bidirecional",
      "two_way_sync_desc" : "Contatos são criados para convidados encontrados em eventos de calendário vinculados, e esses eventos são transformados em compromissos do sistema.",
      "smart_sync" : "Sincronização Inteligente",
      "smart_sync_desc" : "Os eventos do calendário vinculado são sincronizados como compromissos para os contatos existentes. Se nenhum contato existir, eles serão sincronizados como intervalos bloqueados sem criar um novo contato.",
      "sync_option_tooltip" : "Selecione como as ocorrências dos seus calendários externos são sincronizadas com este calendário. Você pode bloquear apenas a disponibilidade ou também criar/gerenciar {contactsLabel} e compromissos aqui, com base no modo de sincronização que você selecionar",
      "one_way_sync_tooltip" : "Blocos Intervalos de dados Via importando eventos ocupados De seus calendários externos",
      "two_way_sync_tooltip" : "Importa reuniões e cria {contactsLabel} e compromissos no sistema. As alterações feitas aqui refletirão nos calendários externos",
      "smart_sync_tooltip" : "Importa reuniões e cria compromissos somente se a conferência foi criada por um {contactLabel} conhecido",
      "default_sync" : "Padrão",
      "default_sync_desc" : "Sincroniza eventos do seu calendário externo com este calendário",
      "advanced_sync" : "Avançado",
      "advanced_sync_desc" : "Sincroniza eventos do seu calendário externo com este calendário e cria contatos e compromissos no sistema",
      "assign_contact_to" : "Atribuir contato a",
      "select_calendar" : "Selecionar calendário",
      "sync_preferences" : "Preferências de sincronização",
      "sync_preferences_desc" : "Como você gostaria de sincronizar seus eventos de calendário vinculados?",
      "recommended" : "Recomendado",
      "execute_automation_desc" : "Executar automação quando uma reunião for criada neste calendário",
      "save" : "Salvar alterações",
      "cancel" : "Cancelar"
    },
    "extras" : {
      "extras" : "Personalizações",
      "extras_sub" : "Estilo do Widget de coleção e outras configurações.",
      "calendar_widget_style" : "Estilo do Widget de calendário",
      "neo" : "Novo",
      "classic" : "Clássico",
      "insert_custom_code" : "Insira código personalizado",
      "show_seats_per_slot" : "Exibir assinaturas por intervalo",
      "allow_reschedule_meeting" : "Habilitar Reagendar Conferência",
      "allow_cancelling_meeting" : "Habilitar cancelamento de conferência",
      "additional_notes" : "Notas adicionais",
      "cancellation_and_reschedule" : "Cancelamento e Reagendado:",
      "allow_staff" : "Habilitar seleção de equipe durante a reserva",
      "code_block_tooltip" : "Scripts de terceiros Interno o bloco HTML podem oferecer uma funcionalidade poderosa, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Portanto, recomendamos que Você para a avaliação do conteúdo deste código antes de salvá-lo para o calendário.",
      "calendar_image" : "Imagem de capa do calendário",
      "remove_image" : "Extrair imagem",
      "calendar_image_info" : "A imagem carregada ficará visível dentro do Grupo Pré-visualizar para o Neo Modelo e não aparecerá Ativado o Link do calendário Indivíduo",
      "get_image_from_unsplash" : "Melhore seu visual com",
      "unsplash" : "Unsplash",
      "service_additional_preferences" : "Configuração Configurações adicionais",
      "service_image" : "Imagem de capa do serviço",
      "service_image_description" : "selecionar uma imagem que seria Comparada Ativado o menu Serviços para este serviço",
      "allow_reschedule_appointment" : "Habilitar Reagendar Compromisso",
      "allow_cancelling_appointment" : "Habilitar cancelamento de compromisso",
      "custom_code_placeholder" : "Por favor, feedback Código personalizado aqui",
      "calendar_widget_style_desc" : "selecionar entre o nosso Clássico ou o esnobrado Widget Neo",
      "seats_per_slot" : "Assentos por intervalo",
      "show_staff_selection" : "Seleção de equipe",
      "seats_per_slot_desc" : " Habilitar o Agendador para pré-visualizar o número de Assentos disponíveis por janela de tempo diretamente ativado do Widget de calendário .",
      "show_staff_selection_desc" : "Habilitar Agendador para selecionar uma equipe Membros diretamente do Widget de calendário durante a reserva de compromisso. Funciona só com o Widget Neo",
      "widget_re_order_tooltip" : "O estilo do Widget Clássico não habilita o Widget Ordenar Dinâmico. Certifique-se de que o seletor de dados de dados seja o primeiro e o formulário seja o segundo antes de selecionar o estilo Clássico.",
      "show_staff_selection_desc_service" : "Habilitar Agendador para selecionar uma equipe Membros diretamente do Widget de calendário durante a reserva de compromisso.",
      "switch_to_classic_widget" : "Mudar para Widget Clássico",
      "switch_to_classic_widget_desc" : "O Dinâmico para o <b> WidgetClássico</b> desabilitará automaticamente as configurações posteriores, pois elas não podem existir:",
      "form_first_disabled" : "<b>O formulário será movido para a segunda Etapa</b> in Ordenar do Widget .",
      "appointment_preference_disabled" : "<b>Nova preferência de compromisso (sempre agende com o usuário atribuído do {contactLabel})</b> será desabilitada. Isso significa que os compromissos podem ser agendados com qualquer membro do grupo disponível, em vez de serem limitados ao usuário atribuído do {contactLabel}.",
      "multiple_location_disabled" : "<b>O endereço de várias conferências</b> será Apagado, e somente a <b>primeira localização adicionada</b> será retida.",
      "insert_custom_code_tooltip" : "Personalizar estilo do Widget Via seu próprio código CSS",
      "classic_tooltip_disabled" : "O widget clássico não é compatível com calendários de reserva de aulas",
      "show_staff_selection_disabled_tooltip" : "A seleção de pessoal é compatível apenas com o widget neo"
    },
    "roomsAndEquipments" : {
      "title" : "selecionar Sala e Equipamentos",
      "description" : "selecionar De a Lista de Sala e Equipamentos o que será reservado com este calendário",
      "rooms" : "Selecionar Sala",
      "equipments" : "Selecionar Equipamentos"
    }
  },
  "activity_log" : {
    "activity_log" : "Registro de atividades",
    "date" : "Data",
    "filter_by" : "Filtrar por",
    "calendar_update" : "Atualização de calendário",
    "start_time_update" : "Atualização da hora de início",
    "end_time_update" : "Atualização da hora de término",
    "title_update" : "Atualização de título",
    "notes_update" : "Atualização de observações",
    "appointment_status_update" : "Atualização de status do compromisso",
    "meeting_location_update" : "Atualização da localização da conferência",
    "google_sync_update" : "Atualização de sincronização do Google",
    "outlook_sync_update" : "Atualização de sincronização do Outlook",
    "assigned_user_update" : "Atualização de usuário atribuído",
    "appointment_status" : "Status do compromisso",
    "assigned_user" : "Usuário atribuído",
    "uploaded_to" : "Carregado para",
    "cancelled" : "Cancelado",
    "edited" : "editado",
    "other_edits" : "Outras edições",
    "view_details" : "Visualizar detalhes",
    "all" : "Todos"
  },
  "appointment_list" : {
    "group_all" : "TODOS",
    "group_primary" : "PRINCIPAL",
    "group_user" : "USUÁRIOS",
    "group_team" : "GRUPOS",
    "group_calendar" : "CALENDÁRIOS",
    "all_appointments" : "Todos os Compromissos",
    "my_calendar" : "Meu calendário",
    "status_all" : "Todos",
    "status_confirmed" : "Confirmado",
    "status_new" : "Novo (ação obrigatória)",
    "status_show" : "Comparecido",
    "status_no_show" : "Não comparecimento",
    "status_cancelled" : "Cancelado",
    "status_invalid" : "Inválido",
    "filter_date_added_desc" : "Data adicionada (Desc)",
    "filter_start_added_desc" : "Data de início (desc)",
    "filter_start_added_asc" : "Data de início ascendente a partir de hoje",
    "button_new_appointment" : "Novo compromisso",
    "name" : "Nome",
    "title" : "Título",
    "requested_time" : "Horário solicitado",
    "date_added" : "Data da adição",
    "calendar" : "Calendário",
    "appointment_owner" : "Proprietário do compromisso",
    "notes" : "Observações",
    "status" : "Status",
    "action_view_detail" : "Visualizar detalhes",
    "action_view_consent" : "Visualizar consentimento",
    "action_view_notes" : "Visualizar observações",
    "action_edit" : "Editar",
    "action_delete" : "Excluir",
    "action_reschedule" : "Reagendar",
    "page_previous" : "Anterior",
    "page_next" : "Seguinte",
    "appointment_notes" : "Observações do compromisso",
    "close" : "Fechar",
    "confirm_delete_header" : "Excluir compromisso",
    "confirm_delete_message" : "Tem certeza de que deseja excluir este compromisso? Essa ação não pode ser desfeita!",
    "confirm_delete_button" : "Excluir",
    "confirm_update_header" : "Atualizar status do compromisso",
    "confirm_update_confirmed_message" : "Tem certeza de que deseja marcar este compromisso como confirmado?",
    "confirm_update_invalid_message" : "Tem certeza de que deseja marcar este compromisso como inválido?",
    "confirm_update_showed_message" : "Tem certeza de que deseja marcar este compromisso como comparecido?",
    "confirm_update_noshow_message" : "Tem certeza de que deseja marcar esta consulta como não comparecimento?",
    "confirm_update_cancelled_message" : "Tem certeza de que deseja marcar este compromisso como cancelado?",
    "confirm_update_button" : "Atualizar",
    "empty_state_title" : "Nenhum compromisso encontrado",
    "empty_state_description" : "Nenhum compromisso encontrado",
    "disable_menu_warning" : "Atualmente, você não tem autorização para visualizar ou editar os detalhes do compromisso, pois o contato associado não está atribuído a você. Entre em contato com o seu administrador para obter mais assistência.",
    "no_contact_warning" : "Você não pode acessar as informações de contato no momento. Isso pode ocorrer porque o contato não está atribuído a você. Entre em contato com seu administrador para obter ajuda.",
    "consent_label" : "Consentimento",
    "ip_address" : "IP",
    "youre_viewing_in" : "Atualmente visualizando em",
    "appointment_delete_msg" : "<b>Observação:</b> o compromisso apagado aqui não será apagado do calendly.",
    "rescheduled" : "Reagendado"
  },
  "add_guest" : {
    "guest_label" : "Convidado(s)",
    "search_placeholder" : "Pesquisar de Amigos",
    "add_new" : "Adicionar novo",
    "save" : "Arquivar",
    "close" : "Fechar",
    "name" : "Nome",
    "phone" : "Telefone",
    "email" : "E-mail",
    "guest_label_count" : "Contagem de Convidado(s)",
    "guest_count_error" : "O Convidado Contagem deve estar entre 1 e 100"
  },
  "languages" : {
    "danish" : "Danish",
    "dutch" : "Dutch",
    "english" : "English",
    "finnish" : "Finnish",
    "french" : "French",
    "french_canada" : "French (Canada)",
    "german" : "German",
    "hungarian" : "Hungarian",
    "italian" : "Italian",
    "norwegian" : "Norwegian",
    "polish" : "Polish",
    "portuguese_brazil" : "Portuguese (Brazil)",
    "portuguese_portugal" : "Portuguese (Portugal)",
    "spanish" : "Spanish",
    "swedish" : "Swedish",
    "turkish" : "Turkish"
  },
  "service_menu_advanced" : {
    "new_service_menu_details_header" : "Detalhes do menu de serviços",
    "select_groups_header" : "Selecionar Serviços",
    "arrange_groups_header" : "Configuração seus serviços",
    "new_service_menu" : "novo menu de serviços",
    "service_menu_sub_title" : "Crie um menu de serviço personalizado para seus clientes in apenas alguns cliques",
    "quick_tip" : "Você pode Incluir Grupo ao menu de serviços",
    "service_menu_name" : "Nome do menu de serviços",
    "service_menu_description" : "Descrição",
    "service_menu_slug" : "URL do serviço",
    "select_groups_calendars" : "selecionar grupo e calendários",
    "select_groups_calendars_desc" : "Adicionar Serviços ao seu menu de serviços",
    "select_all" : "selecionar todos",
    "arrange_groups" : "Configuração ordenada de serviços",
    "arrange_groups_desc" : "determinar o Pipeline de serviços ativado o menu de serviços",
    "arrange_services_quicktip" : "Para Reagendar calendários dentro do Grupo, acesse Grupo > Opções > Reagendar Calendários.",
    "enable_add_guest_desc" : "Habilitar clientes para incluir convidados adicionais ao fazer uma reserva.",
    "enable_multiple_service_desc" : "Habilitar clientes para agendar vários serviços in um compromisso individuais.",
    "enable_staff_selection_desc" : "Habilitar clientes para selecionar a equipe preferida Membros Quando fazer uma reserva.",
    "enable_add_guest" : "Habilitar Adicionar convidados",
    "enable_multiple_service" : "Habilitar seleção de vários serviços",
    "enable_staff_selection" : "Habilitar seleção de equipe",
    "additional_options" : "Opções adicionais",
    "code_block_tooltip" : "Scripts de terceiros Interno o bloco HTML podem oferecer uma funcionalidade poderosa, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Portanto, recomendamos que Você para a avaliação do conteúdo deste código antes de salvá-lo ao menu de serviço.",
    "custom_code_placeholder" : "Por favor, feedback Código personalizado aqui",
    "insert_custom_code" : "Insira código personalizado",
    "no_service" : "Nenhum serviço encontrado",
    "no_service_desc" : " Nenhum serviço encontrado. Criar Serviços e Incluir para o Grupo para Criar um menu de serviços.",
    "learn_more" : "Saiba mais",
    "no_service_selected" : "Nenhum serviço selecionado",
    "create_service_calendars" : "Criar calendários de serviços",
    "alert_description" : " in Ordenar para o menu de serviços da Criar, Você precisa Criar calendários de serviços e Incluir eles para o Grupo",
    "dont_show_again" : "Não exibir isto novamente",
    "service_name_required" : "O nome do menu de serviços é Obrigatório",
    "slug_already_taken" : "Este Slug já está disponível",
    "slug_required" : "Slug é obrigatório",
    "please_enter_name" : "Digite um nome",
    "service_name_placeholder" : "Menu PRINCIPAL",
    "service_slug_placeholder" : "menu principal",
    "form_label" : "Formulário",
    "consent_label" : "Caixa de seleção de Consentimento",
    "consent_input_placeholder" : "Adicionar consentimento Corpo",
    "consent_tooltip" : "Alterne esta opção para permitir a obtenção de consentimento do {contactsLabel} quando eles fornecerem seu número de telefone durante o fluxo de trabalho de agendamento de compromissos.",
    "back_message" : "Voltar para Lista",
    "saving_changes" : "Apenas um minuto — Salvando o Dinâmico mais recente...",
    "payment_provider_warning" : "Aviso! Os menus de serviço agora suportam pagamentos apenas via Stripe e Authorize.net. Como seu provedor padrão é diferente, a cobrança de pagamentos para calendários selecionados com pagamentos ativados será ignorada.",
    "aria" : {
      "consent_form_toggle" : "Alternância do formulário de consentimento",
      "enable_add_guest_toggle" : "Habilitar alternância para adicionar convidado",
      "enable_multiple_services_toggle" : "Habilitar alternância de vários serviços",
      "enable_staff_selection_toggle" : "Habilitar alternância de seleção de equipe"
    }
  },
  "widget_configuration" : {
    "customise_calendar_widget" : "Personalizar Widget de calendário",
    "works_with_neo_widget" : "Funciona só com o Widget Neo",
    "customise_widget_desc" : "Personalizar Aparência do Widget : PRINCIPAL Cor, Plano de fundo Cor e Botão Corpo.",
    "learn_more" : "Saiba mais",
    "primary_settings" : "PRINCIPAL configurações",
    "primary_settings_desc" : "Configuração da PRINCIPAL Cor, Plano de fundo Cor e Outro Configurações de Widget para personalizar seu Widget de calendário",
    "primary_color" : "PRINCIPAL Cor",
    "primary_color_desc" : "Definir o Cor para botão, datas, intervalos de dados e atividades",
    "background_color" : "Cor de Plano de fundo",
    "background_color_desc" : "Coleção o Plano de fundo Cor que funciona como pano de fundo para o seletor de data e hora e o formulário.",
    "button_text" : "Botão Corpo",
    "button_text_desc" : "Personalizar o Corpo exibido Ativado o botão Quando reservando um compromisso",
    "calendar_title" : "Título do calendário",
    "calendar_title_desc" : "O nome do seu calendário",
    "calendar_description" : "Descrição do calendário",
    "calendar_description_desc" : "A descrição inserida",
    "calendar_details" : "Detalhes do calendário",
    "calendar_details_desc" : "Inclui detalhes como Duração, Data e dados, Detalhes recorrentes e fuso horário",
    "reset_to_default" : "Redefinir para o padrão",
    "preview_widget" : "Pré-visualizar o Widget",
    "calendar_title_tooltip" : "Coleção Se o nome do calendário e o nome do grupo (se aplicável) devem estar visíveis Ativado o Widget de agendamento.",
    "calendar_description_tooltip" : "Coleção Se a descrição do calendário deve estar visível Ativado o Widget de agendamento.",
    "calendar_details_tooltip" : "Coleção Se os detalhes das Reuniões de Chave, como Conferência Duração, Dados e dados selecionados e informações de recorrência (se aplicável) devem estar visíveis Ativado o Widget de agendamento.",
    "insert_custom_code_tooltip" : "Personalizar estilo do Widget Via seu próprio código CSS .",
    "staff_selection_tooltip" : "Habilitar Agendador para selecionar uma equipe Membros diretamente do Widget de calendário durante a reserva de compromisso. Funciona somente com o Neo Widget."
  },
  "eventNotification" : {
    "customFields" : "Campos Personalizado",
    "customValues" : "Valores personalizados",
    "guest" : "Convidado",
    "assignedUser" : "Usuário atribuído",
    "additionalEmails" : "E-mails adicionais",
    "list" : {
      "booked" : {
        "title" : "Compromisso agendado (status: não confirmado)",
        "note" : "Esta notificação é enviada quando um novo compromisso é criado com o status de não confirmado.",
        "subTitle" : "Envia uma notificação quando um compromisso é agendado com o status de não confirmado"
      },
      "confirmation" : {
        "title" : "Compromisso agendado (status: confirmado)",
        "note" : "Esta notificação é enviada quando um compromisso é criado ou atualizado para o status de confirmado.",
        "subTitle" : "Envia uma notificação quando um compromisso é confirmado com sucesso"
      },
      "cancellation" : {
        "title" : "Cancelamento",
        "note" : "Esta notificação é enviada quando um compromisso é cancelado, marcado como não comparecimento ou marcado como inválido.",
        "subTitle" : "Envia um alerta quando um compromisso é cancelado"
      },
      "reschedule" : {
        "title" : "Reagendar",
        "note" : "Esta notificação é enviada Quando um compromisso é reagendado. Ele só será acionado se o compromisso estiver in Status de não confirmado ou confirmado .",
        "subTitle" : "Notifica quando um compromisso é reagendado"
      },
      "reminder" : {
        "title" : "Lembrete",
        "note" : "Esta notificação é enviada como Lembrete antes do compromisso. Ele só será acionado se o compromisso estiver in Status de não confirmado ou confirmado .",
        "subTitle" : "Envia um lembrete antes do compromisso"
      },
      "followup" : {
        "title" : "Acompanhamento",
        "note" : "Esta notificação é enviada após o compromisso como um acompanhamento. Ela só será acionada se o compromisso estiver no status de não confirmado, confirmado ou comparecido.",
        "subTitle" : "Envia uma mensagem de acompanhamento após a conclusão do compromisso"
      }
    },
    "saveToastMsg" : "Configurações salvas!",
    "saveToastMsgDesc" : "Suas alterações foram salvas com sucesso",
    "enableSuccess" : "Lembre-se de Habilitado!",
    "disableSuccess" : "Lembre-se de desabilitado!",
    "tooltip" : "Esta notificação foi desabilitada. Habilite-a para fazer alterações.",
    "enabled" : "Habilitado(a)",
    "disabled" : "Desabilitado(a)",
    "statusLabel" : "Rótulos de status",
    "email" : {
      "channelName" : "E-mail",
      "noneTemplate" : "Nenhum",
      "notificationLabel" : "Quem deve receber esta notificação?",
      "sendButtonLabel" : "Enviar e-mail de teste",
      "testEmailLabel" : "E-mail de teste",
      "testEmailPlaceholder" : "Insira o endereço de e-mail do destinatário para teste",
      "body" : "Corpo do e-mail",
      "bodyPlaceholder" : "Digite sua mensagem aqui",
      "subject" : "Assunto",
      "subjectPlaceholder" : "Insira o assunto do e-mail",
      "templateLabel" : "Modelo de e-mail",
      "templatePlaceholder" : "Selecione um modelo de e-mail ou comece do zero",
      "fromNamePlaceholder" : "Inserir nome",
      "fromNameLabel" : "De Nome",
      "fromAddressLabel" : "De endereço",
      "alertEmailAddress" : "Insira os IDs de e-mail (separado Via vírgula)",
      "addMore" : "Adicionar mais",
      "afterAppointmentEnds" : "após o término do compromisso",
      "beforeAppointmentStarts" : "antes do início do compromisso",
      "durationLabel" : "Quando você gostaria de acionar a notificação?",
      "disableEmailNotification" : "Desabilitar notificações por e-mail",
      "enableEmailNotification" : "Habilitar notificações por e-mail",
      "enableSuccess" : "Notificação por e-mail habilitada!",
      "enableSuccessDesc" : "Agora você começará a receber esta notificação",
      "disableSuccess" : "Notificação por e-mail desabilitada!",
      "disableSuccessDesc" : "Você não receberá mais esta notificação",
      "reset_to_default" : "Redefinir para o padrão",
      "testEmailSuccessTitle" : "E-mail de teste enviado!",
      "testEmailSuccessDesc" : "O e-mail de teste foi enviado com sucesso para {email}",
      "testEmailErrorTitle" : "Falha ao enviar e-mail de teste",
      "testEmailErrorDesc" : "Houve um erro ao enviar o e-mail de teste. Tente de novo."
    },
    "inApp" : {
      "channelName" : "No app",
      "title" : "Configurações de notificação",
      "enableInAppNotification" : "Habilitar notificação no aplicativo",
      "disableInAppNotification" : "Desabilitar notificação no app",
      "selectedUser" : {
        "label" : "Enviar para",
        "helperText" : "Esta notificação interna é enviada pela web e por aplicativos móveis",
        "placeholder" : "Selecionar usuário(s)"
      },
      "enableSuccess" : "Notificações no app habilitadas!",
      "enableSuccessDesc" : "Agora você começará a receber esta notificação",
      "disableSuccess" : "Notificações no app desabilitadas!",
      "disableSuccessDesc" : "Você não receberá mais esta notificação"
    },
    "sms" : {
      "channelName" : "SMS",
      "noneTemplate" : "Nenhum",
      "notificationLabel" : "Quem deve receber esta notificação?",
      "sendButtonLabel" : "Enviar SMS de teste",
      "testSMSLabel" : "Teste de SMS (insira o número de telefone com código do país)",
      "testSMSPlaceholder" : "+12345678901",
      "body" : "Mensagem SMS",
      "bodyPlaceholder" : "Digite sua mensagem SMS aqui",
      "durationLabel" : "Quando você gostaria de acionar a notificação?",
      "disableSMSNotification" : "Desabilitar notificações por SMS",
      "enableSMSNotification" : "Habilitar notificações por SMS",
      "enableSuccess" : "Notificação por SMS habilitada!",
      "enableSuccessDesc" : "Agora você começará a receber esta notificação",
      "disableSuccess" : "Notificação por SMS desabilitada!",
      "disableSuccessDesc" : "Você não receberá mais esta notificação",
      "alertPhoneNumbers" : "Insira números de telefone (com códigos de país, separados por vírgulas)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Adicionar mais",
      "afterAppointmentEnds" : "após o término do compromisso",
      "beforeAppointmentStarts" : "antes do início do compromisso",
      "templateLabel" : "Modelo de SMS",
      "templatePlaceholder" : "Selecione o modelo de SMS...",
      "reset_to_default" : "Redefinir para o padrão",
      "testSmsSuccessTitle" : "SMS de teste enviado!",
      "testSmsSuccessDesc" : "O SMS de teste foi enviado com sucesso para {phone}",
      "testSmsErrorTitle" : "Falha ao enviar SMS de teste",
      "testSmsErrorDesc" : "Houve um erro ao enviar o SMS de teste. Tente de novo."
    },
    "whatsapp" : {
      "channelName" : "WhatsApp",
      "notificationLabel" : "Quem deve receber esta notificação?",
      "sendButtonLabel" : "Enviar notificação de teste por WhatsApp",
      "testWhatsAppLabel" : "Teste de notificação por WhatsApp (insira o número de telefone com o código do país)",
      "testWhatsAppPlaceholder" : "+12345678901",
      "durationLabel" : "Quando você gostaria de acionar a notificação?",
      "alertPhoneNumbers" : "Insira números de telefone (com códigos de país, separados por vírgulas)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Adicionar mais",
      "afterAppointmentEnds" : "após o término do compromisso",
      "beforeAppointmentStarts" : "antes do início do compromisso",
      "templateLabel" : "Modelo do WhatsApp",
      "templatePlaceholder" : "Selecione o modelo do WhatsApp...",
      "noPreview" : "Nenhum modelo selecionado",
      "templateRequired" : "Modelo obrigatório",
      "testWhatsAppSuccessTitle" : "Notificação de teste por WhatsApp enviada!",
      "testWhatsAppSuccessDesc" : "A notificação de teste por WhatsApp foi enviada com êxito para {phone}",
      "testWhatsAppErrorTitle" : "Falha ao enviar notificação de teste por WhatsApp",
      "testWhatsAppErrorDesc" : "Ocorreu um erro ao enviar a notificação de teste por WhatsApp. Tente de novo.",
      "setupTitle" : "Entre em contato com o cliente no aplicativo de mensagens favorito dele",
      "setupDescription" : "Mantenha-se mais próximo de seus clientes fornecendo suporte instantâneo, enviando atualizações oportunas e criando interações envolventes.",
      "connectWhatsApp" : "Conectar o WhatsApp",
      "checkingStatus" : "Verificando o status da conta do WhatsApp...",
      "checkingTemplateStatus" : "Verificando o status do modelo do WhatsApp...",
      "statusCheckError" : "Falha ao verificar o status da conta do WhatsApp",
      "templateStatusCheckError" : "Falha ao verificar o status do modelo do WhatsApp",
      "setupTemplateTitle" : "Conclua a configuração do seu modelo do WhatsApp",
      "setupTemplateDescription" : "Você precisa configurar modelos do WhatsApp antes de poder enviar notificações. Clique abaixo para concluir o processo de configuração.",
      "loadTemplatesError" : "Falha ao carregar modelos do WhatsApp",
      "templatesRefreshed" : "Modelos atualizados com sucesso",
      "templatesRefreshError" : "Falha ao atualizar os modelos",
      "templatesResolveError" : "Erro ao resolver os modelos padrão do WhatsApp",
      "locationNotFound" : "Id de localização não encontrado",
      "settingsRedirectError" : "Não foi possível redirecionar para as configurações do WhatsApp",
      "updateNotificationError" : "Falha ao atualizar notificação por WhatsApp",
      "notificationsEnabled" : "Notificações por WhatsApp habilitadas!",
      "notificationsDisabled" : "Notificações por WhatsApp desabilitadas!",
      "updateError" : "Erro ao atualizar notificações",
      "createNewTemplate" : "Criar novo modelo do WhatsApp",
      "phoneValidation" : {
        "countryCodeRequired" : "O número de telefone deve começar com um código do país (por exemplo, +1, +91, +44)",
        "digitsOnly" : "O número de telefone deve conter apenas dígitos após o código do país",
        "tooShort" : "O número de telefone é muito curto",
        "tooLong" : "O número de telefone é muito longo",
        "invalid" : "Número de telefone inválido"
      },
      "errors" : {
        "templateNotFound" : "ID do modelo não encontrado nas opções carregadas, limpando",
        "templateNoLongerValid" : "Modelo salvo não é mais válido, limpando",
        "invalidTemplateSelection" : "Tentativa de selecionar um modelo do WhatsApp inválido",
        "fetchingTemplates" : "Erro ao buscar modelos do WhatsApp",
        "mountingCreator" : "Erro ao montar o Criador de modelos do WhatsApp",
        "fetchingAfterCreation" : "Erro ao buscar modelos do WhatsApp após a criação",
        "updateStatus" : "Erro ao atualizar o status do WhatsApp"
      },
      "receiverLabels" : {
        "assignedUser" : "Usuário atribuído",
        "phoneNumbers" : "Números de telefone adicionais"
      }
    }
  },
  "smsTemplate" : {
    "create_new_template" : "Criar novo modelo de SMS",
    "create_new_template_desc" : "Crie um modelo de SMS reutilizável para suas notificações",
    "template_name" : "Nome do modelo",
    "template_name_placeholder" : "Insira o nome do modelo",
    "message" : "Mensagem",
    "message_placeholder" : "Digite sua mensagem SMS aqui",
    "create_template" : "Criar modelo",
    "name_required" : "O nome do modelo é obrigatório",
    "text_required" : "O texto da mensagem é obrigatório",
    "fetch_new_templates" : "Atualizar modelos"
  },
  "whatsappTemplate" : {
    "create_new_template" : "Criar novo modelo do WhatsApp",
    "create_new_template_desc" : "Crie um modelo do WhatsApp reutilizável para suas notificações",
    "template_name" : "Nome do modelo",
    "template_name_placeholder" : "Insira o nome do modelo",
    "message" : "Mensagem",
    "message_placeholder" : "Digite aqui sua mensagem do WhatsApp",
    "create_template" : "Criar modelo",
    "name_required" : "O nome do modelo é obrigatório",
    "text_required" : "O texto da mensagem é obrigatório",
    "fetch_new_templates" : "Atualizar modelos"
  },
  "archivedServices" : {
    "servicesBanner" : "Uma nova Versão de Serviços atualizada está aqui— mais poderosa, compatível com as opções de pagamento e descompromisso. Seus calendários de serviços já foram Migrados. explore-os agora in aba Serviços.",
    "archivedServiceCalendars" : "Calendários de serviços (v1)",
    "check_new_services" : "Marca de seleção novo serviços"
  },
  "tour" : {
    "hidden_test_label" : "Testar",
    "calendar" : {
      "edit_calendar" : "Editar calendário",
      "share_calendar" : "Compartilhar calendário",
      "troubleshoot_calendar" : "Solucionar problemas de calendário",
      "more_options" : "Mais Opções",
      "edit_calendar_desc" : "Gerenciar todas as configurações do calendário - Fixa Disponibilidade, Configuração Lembrete, Modificar limite de compromisso e muito mais.",
      "share_calendar_desc" : "Copie e compartilhe seu Link de programação para que o Agendador possa programar facilmente com Você.",
      "troubleshoot_calendar_desc" : "Descubra por que um intervalo não está sendo exibido e visualize os possíveis motivos na solução de problemas.",
      "more_options_desc" : "Acesso configurações e atividades adicionais para gerenciar seu calendário.",
      "read_permissions" : {
        "share_description" : "Conceda acesso a outras pessoas compartilhando o link do calendário ou ajustando as permissões.",
        "troubleshoot_description" : "Identifique e resolva problemas como erros de sincronização ou eventos ausentes para uma funcionalidade uniforme."
      },
      "next" : "Próximo",
      "start_over" : "Começar de novo",
      "all_set" : "todos coleção!",
      "previous" : "Anterior"
    }
  },
  "emailTemplate" : {
    "select_editing_experience" : "Selecionar sua oportunidade de edição",
    "select_editing_experience_desc" : "selecionar para criar Via nosso Editor de criação visual de arraste e solte Ou poderosa Editor de código",
    "design_editor" : "Criar Editor",
    "design_editor_desc" : "Edição visual, Arrastar e solte.",
    "code_editor" : "Editor de código",
    "code_editor_desc" : "Edição de HTML cheia de recursos.",
    "text_editor" : "Editor de código plano",
    "text_editor_desc" : "Edição de corpo simples, limpo e sem detalhes.",
    "email_text_block" : "O e-mail também pode ser bloco Criado Via Corpo. ",
    "select" : "Selecionar",
    "new_template" : "novo Modelo",
    "email_block" : "O e-mail também pode ser bloco Criado Via Corpo.",
    "fetch_new_templates" : "Buscar novos modelos"
  },
  "quick_tips" : {
    "meeting_details" : {
      "include_contact_and_user_names" : "Para incluir o nome do contato e o nome do usuário do compromisso no título da reunião, use o seguinte formato: &#123;&#123;contact.name&#125;&#125; X &#123;&#123;appointment.user.name&#125;&#125;",
      "add_backup_meeting_url" : "Para garantir acesso ininterrupto, adicione um URL de reunião personalizado como opção de backup caso haja algum problema com as integrações do Zoom ou do Gmeet.",
      "enable_gmeet_primary" : "Para habilitar a funcionalidade do Gmeet, certifique-se de que o Google Agenda do membro da equipe esteja definido como sua agenda principal nas configurações."
    },
    "availability" : {
      "twenty_four_hours" : "Para tornar o calendário disponível 24 horas, defina o intervalo de tempo de 00:00 às 00:00.",
      "update_timezone_preferences" : "Os fusos horários podem ser alterados a qualquer momento em Perfil da empresa >> Preferências de fuso horário.",
      "service_calendar_slot_interval" : "Defina a disponibilidade do seu calendário de serviços, com um intervalo padrão de 15 minutos entre os compromissos."
    },
    "forms" : {
      "create_custom_forms" : "Crie facilmente formulários personalizados na seção Marketing em \"Formulários\" e integre-os perfeitamente aos calendários para uma coleta de dados organizada.",
      "apply_sticky_contacts" : "Ao adicionar um formulário personalizado, as configurações de contatos fixos vinculadas ao formulário serão aplicadas automaticamente.",
      "use_custom_values" : "Você tem a opção de incluir valores e campos personalizados de contatos na mensagem do formulário e no URL do formulário."
    },
    "notifications" : {
      "use_workflows" : "Para notificações avançadas, use os gatilhos Fluxos de trabalho ou Compromissos agendados."
    },
    "customizations" : {
      "update_widget_language" : "Para alterar as configurações de idioma do widget, siga estas etapas: Configurações >> Calendários >> Preferências >> Preferências da conta."
    },
    "equipments" : {
      "room_definition" : "Uma \"sala\" pode representar qualquer local onde serviços são fornecidos. Podem ser salas físicas e/ou estações dedicadas. Ex.: Estação de pedicure.",
      "equipment_definition" : "\"Equipamento\" são ferramentas ou dispositivos que as empresas usam para cumprir compromissos. Podem incluir máquinas, dispositivos ou mesmo cadeiras."
    }
  },
  "aria_labels" : {
    "sticky_contacts" : "Contatos importantes",
    "consent_form" : "Formulário de Consentimento",
    "enable_guests" : "Habilitar convidados",
    "auto_confirm" : "Confirmação automática",
    "should_accept_payment" : "Deve aceitar pagamento",
    "collect_deposit" : "Coletar depósito",
    "enable_charge_guests" : "Habilitar cobrança de convidados",
    "enable_coupon" : "Ativar cupom",
    "payment_live" : "Pagamento ao vivo",
    "add_availability_hour" : "Adicionar hora de disponibilidade",
    "remove_availability_hour" : "Remover hora de disponibilidade",
    "copy_availability_hour" : "Copiar hora de disponibilidade",
    "close_modal" : "Fechar modal",
    "add_custom_slot" : "Adicionar intervalo personalizado",
    "remove_custom_slot" : "Remover intervalo personalizado",
    "edit_custom_slot" : "Editar intervalo personalizado",
    "update_frequency" : "Atualizar frequência",
    "show_calendar_title" : "Exibir título do calendário",
    "show_calendar_description" : "Exibir descrição do calendário",
    "show_calendar_details" : "Exibir informações do calendário",
    "allow_reschedule" : "Permitir reagendamento",
    "allow_cancellation" : "Permitir cancelamento",
    "category_actions" : "Ações da categoria"
  },
  "placeholders" : {
    "pixel_id" : "ID do pixel",
    "select_one" : "Selecionar um",
    "meeting_location" : "Localização da conferência",
    "schedule_meeting" : "Agendar conferência",
    "notes" : "Notas",
    "select_users" : "Selecionar usuários"
  },
  "alt_text" : {
    "payment_provider" : "Provedor de pagamento",
    "no_calendars" : "Sem calendários",
    "date_specific_hours" : "horas específicas da data",
    "custom_widget_image" : "Imagem de widget personalizado",
    "service_calendar" : "Calendário de serviços",
    "event_calendar" : "Calendário de eventos",
    "round_robin_booking" : "Agendamento por rodízio",
    "class_booking" : "Reserva de aula",
    "collective_booking" : "Reserva coletiva"
  },
  "tooltips" : {
    "text_color" : "Cor do texto",
    "background_color" : "Cor do plano de fundo",
    "strikethrough" : "Tachar",
    "superscript" : "Sobrescrito",
    "subscript" : "Subscrito",
    "inline_code_block" : "Bloco de código embutido",
    "code_block" : "Bloco de código",
    "block_quote" : "Citação em bloco",
    "more" : "Mais",
    "upload" : "Carregar"
  },
  "labels" : {
    "reset_style" : "Redefinir estilo",
    "reset_document_style" : "Redefinir estilo do documento",
    "source_code" : "Código-fonte",
    "success" : "Sucesso",
    "edit" : "Editar",
    "submit" : "Enviar",
    "cancel" : "Cancelar",
    "payment" : "Pagamento",
    "here_is_the_link" : "Aqui está o link:",
    "here_is_the_embed_code" : "Aqui está o código de incorporação:",
    "service_calendar" : "Calendário de serviços",
    "collective_booking" : "Reserva coletiva",
    "class_booking" : "Reserva de aula",
    "round_robin_booking" : "Agendamento por rodízio",
    "event_calendar" : "Calendário de Eventos",
    "personal_booking" : "Agendamento pessoal",
    "service_booking" : "Agendamento de serviço"
  },
  "validation_messages" : {
    "calendar_group_name_required" : "O nome do Grupo de Calendário é obrigatório",
    "calendar_group_description_required" : "A descrição do Grupo de Calendário é obrigatória",
    "slug_required" : "O slug é obrigatório",
    "slug_not_valid" : "Este slug não é válido",
    "slug_already_taken" : "Este slug já está tomado",
    "error_validating_slug" : "Erro ao validar slug",
    "please_enter_name" : "Insira um nome",
    "room_name_required" : "O nome da sala é obrigatório",
    "equipment_name_required" : "O nome do equipamento é obrigatório",
    "subject_required" : "O assunto é obrigatório",
    "this_is_required" : "Isto é obrigatório",
    "calendar_group_slug_required" : "O slug do Grupo de Calendário é obrigatório",
    "capacity_mandatory" : "Capacidade é obrigatória",
    "capacity_cannot_be_zero" : "A capacidade não pode ser zero",
    "capacity_should_be_a_number" : "A capacidade deve ser um número",
    "capacity_cannot_be_negative" : "A capacidade não pode ser negativa",
    "capacity_should_be_a_whole_number" : "A capacidade deve ser um número inteiro",
    "quantity_mandatory" : "Quantidade é obrigatória",
    "quantity_cannot_be_zero" : "A quantidade não pode ser zero",
    "quantity_should_be_a_number" : "A quantidade deve ser um número",
    "quantity_cannot_be_negative" : "A quantidade não pode ser negativa",
    "quantity_should_be_a_whole_number" : "A quantidade deve ser um número inteiro",
    "quantity_cannot_be_less_than_out_of_service_equipments" : "A quantidade não pode ser inferior aos equipamentos fora de serviço",
    "out_of_service_value_should_be_a_number" : "O valor fora de serviço deve ser um número",
    "out_of_service_cannot_be_negative" : "Fora de serviço não pode ser negativo",
    "out_of_service_equipments_qty" : "O número de equipamentos fora de serviço não pode ser superior à quantidade real de equipamentos",
    "out_of_service_whole_number" : "Fora de serviço deve ser um número inteiro",
    "slot_duration_required" : "A duração do intervalo é obrigatória",
    "slot_duration_integer" : "A duração do slot deve ser um número inteiro",
    "meeting_duration_validation" : "A duração da reunião deve estar entre 1 min e 12 horas",
    "seats_class_required" : "Assentos por aula é obrigatório",
    "seats_class_integer" : "Assentos por aula devem ser um número inteiro",
    "seats_class_validation" : "Isso não pode ser maior que 9999 nem menor que 0",
    "meeting_location_required" : "O local da reunião é obrigatório"
  },
  "custom_values" : {
    "assigned_user" : "Usuário atribuído",
    "full_name" : "Nome completo",
    "first_name" : "Nome",
    "last_name" : "Sobrenome",
    "email" : "E-mail",
    "phone" : "Telefone",
    "twilio_phone" : "Telefone Twilio",
    "account" : "Conta",
    "name" : "Nome",
    "full_address" : "Endereço completo",
    "city" : "Cidade",
    "state" : "Estado",
    "country" : "País",
    "postal_code" : "Código postal",
    "contact" : "Contato",
    "address1" : "Endereço 1",
    "timezone" : "Fuso horário",
    "user" : "Usuário",
    "appointment" : "Compromisso",
    "start_date_time" : "Data e hora de início",
    "start_date" : "Data de início",
    "start_time" : "Horário de início",
    "end_date_time" : "Data e hora de término",
    "end_date" : "Data de término",
    "end_time" : "Horário de término",
    "meeting_location" : "Localização da conferência"
  },
  "meeting_location_types" : {
    "zoom" : "Zoom",
    "google_meet" : "Google Meet",
    "phone" : "Telefone",
    "full_address" : "Endereço completo",
    "microsoft_teams" : "Microsoft Teams",
    "custom" : "Personalizado"
  },
  "duration_units" : {
    "minutes" : "Minutos",
    "hours" : "Horas"
  },
  "widget_styles" : {
    "classic" : "Clássico",
    "neo" : "Neo"
  },
  "feature_labels" : {
    "service_menu" : "Menu de serviços",
    "rooms" : "Salas",
    "equipments" : "Equipamentos"
  },
  "lsa" : {
    "categories" : {
      "accountant" : "Contabilidade",
      "acupuncturist" : "Acupuntura",
      "air_duct_cleaner" : "Limpeza de dutos de ar",
      "alcohol_treatment" : "Serviços de tratamento de alcoolismo",
      "animal_shelter" : "Serviços de Resgate de Animais",
      "appliance_repair" : "Reparo de eletrodomésticos",
      "architect" : "Arquitetura",
      "assisted_living" : "Serviços de assistência à vida",
      "babysitter" : "Babá",
      "bankruptcy_lawyer" : "Lei de falências",
      "beauty_school" : "Escola de beleza",
      "business_lawyer" : "Direito Empresarial",
      "car_repair" : "Serviços automotivos",
      "carpenter" : "Carpintaria",
      "carpet_cleaning" : "Limpeza de Carpetes",
      "child_care" : "Serviços de cuidados infantis",
      "chiropractor" : "Serviços de Quiropraxia",
      "cleaning_service" : "Limpeza residencial",
      "contract_lawyer" : "Direito Contratual",
      "countertop_pro" : "Serviços de bancadas",
      "criminal_lawyer" : "Direito Penal",
      "dance_instructor" : "Instrução de dança",
      "disability_lawyer" : "Direito das pessoas com deficiência",
      "driving_instructor" : "Instrução de direção",
      "dui_lawyer" : "Lei sobre condução sob influência de substâncias psicoativas",
      "electrician" : "Elétrica",
      "energy_efficiency_pro" : "Serviços de Eficiência Energética",
      "estate_lawyer" : "Direito imobiliário",
      "event_planner" : "Planejamento de Eventos",
      "family_lawyer" : "Direito de Família",
      "fencing_pro" : "Cercamento",
      "financial_planner" : "Planejamento financeiro",
      "first_aid_trainer" : "Treinamento de primeiros socorros",
      "flooring_pro" : "Pisos",
      "foundation_pro" : "Fundamentos",
      "funeral_home" : "Serviços Funerários",
      "garage_door_pro" : "Porta de Garagem",
      "general_contractor" : "Melhorias domésticas",
      "handyman" : "Faz-tudo",
      "home_inspector" : "Inspeção residencial",
      "home_security" : "Serviços de segurança residencial",
      "home_theater" : "Serviços de home theater",
      "hvac" : "HVAC",
      "immigration_lawyer" : "Lei de Imigração",
      "interior_designer" : "Estilização de interiores",
      "ip_lawyer" : "Direito de Propriedade Intelectual",
      "junk_removal" : "Remoção de lixo",
      "labor_lawyer" : "Lei trabalhista",
      "landscaper" : "Paisagismo",
      "language_instructor" : "Instrução de idiomas",
      "lawn_care" : "Cuidados com o gramado",
      "litigation_lawyer" : "Direito Contencioso",
      "locksmith" : "Serralheiro",
      "malpractice_lawyer" : "Lei de negligência médica",
      "massage_center" : "Serviços de massagem",
      "massage_school" : "Escola de massagem",
      "mover" : "Movendo",
      "nursing_home" : "Serviço de lar de idosos",
      "painter" : "Pintura",
      "personal_injury_lawyer" : "Lei de lesões corporais",
      "personal_trainer" : "Treinamento pessoal",
      "pest_control" : "Controle de pragas",
      "pet_adoption" : "Serviços de adoção de pets",
      "pet_boarding" : "Hospedagem para pets",
      "pet_grooming" : "Serviços de tosa para pets",
      "pet_trainer" : "Treinamento de pets",
      "photographer" : "Fotografia",
      "plumber" : "Encanamento",
      "pool_cleaner" : "Limpeza de Piscinas",
      "pool_contractor" : "Contratação de piscinas",
      "preschool" : "Pré-escola",
      "psychologist" : "Serviços de Psicologia",
      "real_estate_agent" : "Imóveis",
      "real_estate_lawyer" : "Direito Imobiliário",
      "rehab" : "Serviços de Reabilitação",
      "roofer" : "Cobertura",
      "sewage_pro" : "Serviços de sistema de esgoto",
      "siding_pro" : "Revestimento",
      "smart_home" : "Serviços para casas inteligentes",
      "snow_removal" : "Serviços de Remoção de Neve",
      "spa" : "Serviços de Spa",
      "tax_lawyer" : "Direito tributário",
      "tax_specialist" : "Serviços fiscais",
      "therapist" : "Terapia",
      "towing_pro" : "Assistência rodoviária",
      "traffic_lawyer" : "Lei de trânsito",
      "tree_service" : "Serviços para árvores",
      "tutor" : "Tutoria",
      "upholstery_cleaner" : "Limpeza de estofados",
      "veterinarian" : "Serviços Veterinários",
      "videographer" : "Serviços de Vídeo",
      "water_damage" : "Serviços de danos causados pela água",
      "weight_loss_service" : "Serviços de perda de peso",
      "window_cleaner" : "Limpeza de janelas",
      "window_repair" : "Serviços de Janelas",
      "windshield_repair_pro" : "Vidros automotivos",
      "yoga_instructor" : "Ioga"
    },
    "job_types" : {
      "accountant_other" : "Outro",
      "bankruptcy_tax_litigation" : "Litígio de impostos de falência",
      "bookkeeping" : "Contabilidade",
      "business_consulting" : "Consultoria empresarial",
      "debt_collection_relief" : "Alívio de cobrança de dívidas",
      "irs_representation_resolution" : "Representação e Resolução do IRS",
      "payroll" : "Folha de pagamento",
      "tax_planning_business" : "Planejamento tributário empresarial",
      "tax_planning_individual" : "Planejamento tributário individual",
      "tax_return_business" : "Declaração de Imposto de Renda Empresarial",
      "tax_return_individual" : "Declaração de Imposto de Renda Individual",
      "trusts_estates_accounting" : "Contabilidade de patrimônios e fundos",
      "acupressure" : "Acupressão",
      "acupuncture" : "Acupuntura",
      "acupuncturist_other" : "Outro",
      "cupping" : "Ventosas",
      "gua_sha" : "Gua Sha",
      "heat_therapy" : "Terapia de calor",
      "herbal_therapy" : "Fitoterapia",
      "infrared_therapy" : "Terapia Infravermelha",
      "moxibustion" : "Moxabustão",
      "qigong" : "Qigong",
      "shiatsu" : "Shiatsu",
      "tui_na" : "Tui Na",
      "air_duct_cleaning" : "Limpeza de Dutos de Ar",
      "air_duct_filter_replacement" : "Substituição do filtro",
      "air_duct_other" : "Outro",
      "dryer_vent_cleaning" : "Limpeza de dutos de secadora",
      "furnace_cleaning" : "Limpeza de fornos",
      "indoor_air_quality_testing" : "Teste de qualidade do ar interno",
      "alcohol_treatment_other" : "Outro",
      "animal_shelter_cat_adoption" : "Adoção de Gatos",
      "animal_shelter_dog_adoption" : "Adoção de cães",
      "animal_shelter_other" : "Outro",
      "animal_shelter_other_animal_adoption" : "Adoção de outros animais",
      "animal_shelter_other_veterinary_services" : "Outros serviços veterinários",
      "animal_shelter_spay_neuter" : "Castrar ou esterilizar",
      "animal_shelter_vaccinations" : "Vacinas",
      "lost_stray_found_animals" : "Animais perdidos, extraviados ou encontrados",
      "pet_license" : "Licença para pets",
      "pet_surrender" : "Entrega de pets",
      "appliance_other" : "Outro",
      "repair_dishwasher" : "Reparar máquina de lavar loiça",
      "repair_dryer" : "Reparar secadora",
      "repair_freezer" : "Conserto de freezer",
      "repair_microwave" : "Conserto de micro-ondas",
      "repair_oven" : "Reparar forno",
      "repair_refrigerator" : "Conserto de refrigerador",
      "repair_refrigerator_freezer" : "Conserto de refrigerador/congelador",
      "repair_stove_cooktop" : "Reparar fogão/cooktop",
      "repair_stove_cooktop_oven" : "Conserto de fogão / cooktop / forno",
      "repair_washer" : "Conserto de lavadora",
      "repair_washer_dryer" : "Conserto de lavadora/secadora",
      "3d_architectural_rendering" : "Renderização Arquitetônica 3D",
      "adaptive_reuse_historical_renovation" : "Reutilização adaptativa e restauração histórica",
      "architect_other" : "Outro",
      "architectural_designing" : "Design arquitetônico",
      "architectural_engineering" : "Engenharia arquitetônica",
      "building_code_analysis_permit_coordination" : "Análise de código e permissões",
      "consulting" : "Consultoria",
      "home_building_improvement" : "Construção e melhoria de residências",
      "interior_design_architect" : "Estilização de interiores",
      "planning_zoning_approval_assistance" : "Aprovação de Planejamento e Zoneamento",
      "project_managing_architect" : "Gerenciamento de Projetos",
      "site_master_planning" : "Planejamento mestre do local",
      "assisted_living_housekeeping_and_laundry" : "Serviços de limpeza e lavanderia",
      "assisted_living_meal_services" : "Serviços de refeições",
      "assisted_living_memory_care" : "Cuidados com a memória",
      "assisted_living_other" : "Outro",
      "assisted_living_rehabilitation_services" : "Serviços de Reabilitação",
      "assisted_living_transportation" : "Transporte",
      "assisted_living_wellness_programs" : "Programas de bem-estar",
      "daily_living_assistance" : "Assistência à vida diária",
      "medication_management" : "Gestão de medicamentos",
      "short_term_stays" : "Estadias de curta duração",
      "social_and_recreational_activities" : "Atividades Recreativas",
      "babysitter_other" : "Outro",
      "event_babysitting" : "Babá para eventos",
      "homework_assistance" : "Assistência para tarefas",
      "housekeeping_laundry" : "Serviços de limpeza e lavanderia",
      "meal_preparation" : "Preparação de Refeições",
      "nanny_services" : "Serviços de Babá",
      "overnight_babysitting" : "Babá durante a noite",
      "pick_up_and_drop_off" : "Retirada e devolução",
      "shopping_errand" : "Compras e tarefas",
      "special_needs_care" : "Cuidados com necessidades especiais",
      "virtual_babysitting" : "Babá virtual",
      "agriculture_bankruptcy" : "Falência no setor agrícola",
      "bankruptcy_lawyer_other" : "Outro",
      "bankruptcy_litigation" : "Litígio de Falência",
      "chapter_11_bankruptcy" : "Falência do Capítulo 11",
      "chapter_13_bankruptcy" : "Capítulo 13 Falência",
      "chapter_7_bankruptcy" : "Falência do Capítulo 7",
      "corporate_bankruptcy" : "Falência corporativa",
      "creditor_harassment" : "Assédio de Credores",
      "debt_settlement" : "Pagamento de dívidas",
      "foreclosure_bankruptcy_lawyer" : "Execução hipotecária",
      "personal_bankruptcy" : "Falência Pessoal",
      "repossession" : "Reintegração de posse",
      "wage_garnishment" : "Penhora salarial",
      "beauty_school_barbering" : "Barbearia",
      "beauty_school_business_management" : "Gestão de empresa",
      "beauty_school_cosmetology" : "Cosmetologia",
      "beauty_school_esthetics" : "Estética",
      "beauty_school_hair_cutting" : "Corte de cabelo",
      "beauty_school_hair_design" : "Design de cabelo",
      "beauty_school_makeup" : "Maquiagem",
      "beauty_school_massage_therapy" : "Massoterapia",
      "beauty_school_nail_technology" : "Tecnologia de unhas",
      "beauty_school_other" : "Outro",
      "beauty_school_retail_training" : "Treinamento em varejo",
      "banking_finance_law" : "Bancos e finanças",
      "business_lawyer_other" : "Outro",
      "business_licenses_permits" : "Licenças e autorizações comerciais",
      "business_litigation" : "Litígio empresarial",
      "business_taxes" : "Impostos empresariais",
      "business_transactions_business_lawyer" : "Transações comerciais",
      "commercial_bankruptcy" : "Falência comercial",
      "commercial_contracts_business_lawyer" : "Contratos Comerciais",
      "employment_law_business_lawyer" : "Direito do Trabalho",
      "incorporation_restructuring" : "Incorporação e reestruturação",
      "insurance_law" : "Lei de seguros",
      "intellectual_property_law" : "Direito de Propriedade Intelectual",
      "mergers_acquisitions_business_lawyer" : "Fusões e Aquisições",
      "partnership_agreements_business_lawyer" : "Acordos de Parceria",
      "patents_copyrights_trademarks" : "Patentes, direitos autorais e marcas registradas",
      "securities_law" : "Lei de Valores Mobiliários",
      "shareholder_disputes" : "Disputas entre acionistas",
      "air_and_cabin_filter" : "Filtro de ar e cabine",
      "battery" : "Bateria",
      "body_and_trim" : "Corpo e aparar",
      "brakes" : "Freios",
      "car_air_conditioning" : "Ar Condicionado",
      "car_electrical" : "Elétrica",
      "car_repair_other" : "Outro",
      "check_engine_light_diagnostic" : "Diagnóstico da luz de verificação do motor",
      "exhaust" : "Escapamento",
      "oil_change" : "Troca de óleo",
      "steering_suspension" : "Direção/Suspensão",
      "tires" : "Pneus",
      "transmission" : "Transmissão",
      "cabinetry" : "Marcenaria",
      "carpenter_other" : "Outro",
      "decking" : "Deques",
      "drywalling" : "Drywall",
      "fencing" : "Cercamento",
      "general_installations" : "Instalações Gerais",
      "general_repairs_maintenance" : "Reparos Gerais e Manutenção",
      "remodeling" : "Reforma",
      "shelving_storage" : "Estantes e armazenamento",
      "carpet_cleaning_other" : "Outro",
      "clean_area_rugs" : "Limpeza de tapetes",
      "clean_carpet" : "Limpar Carpete",
      "clean_drapes_and_curtains" : "Limpeza de cortinas e persianas",
      "clean_upholstery" : "Limpeza de estofados",
      "remove_pet_stains_and_odors" : "Remover machas e odores de pets",
      "after_school_care" : "Cuidados pós-escolares",
      "all_hours_daycare" : "Creche 24 horas",
      "bilingual_daycare" : "Creche Bilíngue",
      "child_care_other" : "Outro",
      "drop_in_daycare" : "Creche sem hora marcada",
      "full_time_daycare" : "Creche em período integral",
      "in_home_daycare" : "Creche domiciliar",
      "infant_programs" : "Programas para bebês",
      "part_time_daycare" : "Creche de meio período",
      "pre_kindergarten_programs" : "Programas de pré-escola",
      "preschool_programs" : "Programas pré-escolares",
      "school_age_programs" : "Programas para crianças em idade escolar",
      "special_needs_daycare" : "Creche para necessidades especiais",
      "summer_daycare" : "Creche de verão",
      "toddler_programs" : "Programas para bebês",
      "weekend_daycare" : "Grade de final de semana",
      "chiropractor_acupuncture" : "Acupuntura",
      "chiropractor_chiropractic" : "Quiropraxia",
      "chiropractor_massage_therapy" : "Terapia de Massagem",
      "chiropractor_other" : "Outro",
      "diagnosis" : "Diagnóstico",
      "eastern_medicine" : "Medicina Oriental",
      "exercise_counseling" : "Aconselhamento sobre exercícios",
      "pain_management" : "Gerenciamento da dor",
      "physical_therapy" : "Fisioterapia",
      "spinal_adjustments" : "Ajustes da coluna",
      "sports_medicine" : "Medicina Esportiva",
      "cleaner_other" : "Outro",
      "deep_clean" : "Limpeza Profunda",
      "moving_clean" : "Limpeza de mudanças",
      "office_clean" : "Limpeza de Escritório",
      "standard_clean" : "Limpeza padrão",
      "assignment_of_contract" : "Cessão de contrato",
      "business_transactions_contract_lawyer" : "Transações comerciais",
      "commercial_contracts_contract_lawyer" : "Contratos comerciais",
      "contract_dispute" : "Disputa contratual",
      "contract_lawyer_other" : "Outro",
      "contract_negotiation" : "Negociação de acordos",
      "contract_review" : "Revisão de contrato",
      "employment_contracts_contract_lawyer" : "Contratos de trabalho",
      "franchise_agreements" : "Contratos de franquia",
      "mergers_acquisitions_contract_lawyer" : "Fusões e aquisições",
      "non_disclosure_agreements_contract_lawyer" : "Acordos de Confidencialidade",
      "partnership_agreements_contract_lawyer" : "Acordos de Parceria",
      "power_of_attorney_contract_lawyer" : "Procuração",
      "security_agreements" : "Acordos de segurança",
      "warranties" : "Garantias",
      "bathroom_countertops" : "Bancadas de banheiro",
      "bathroom_wall_panels" : "Painéis de Parede para Banheiro",
      "countertop_design" : "Design da banca",
      "countertop_installation" : "Instalação de Bancada",
      "countertop_pro_other" : "Outro",
      "fireplace_facade" : "Fachada de lareira",
      "granite_countertops" : "Bancadas de granito",
      "kitchen_countertops" : "Bancadas de cozinha",
      "kitchen_wall_panels" : "Painéis de parede para cozinha",
      "laminate_countertops" : "Bancadas de Laminado",
      "marble_countertops" : "Bancadas de mármore",
      "quartz_countertops" : "Bancadas de Quartzo",
      "remodeling_countertop_pro" : "Reforma",
      "repair_maintenance_countertop_pro" : "Reparo e Manutenção",
      "stone_slab_countertops" : "Bancadas de pedra",
      "tile_countertops" : "Bancadas de azulejos",
      "corporate_representation" : "Representação Corporativa",
      "criminal_immigration_defense" : "Defesa criminal em imigração",
      "criminal_lawyer_other" : "Outro",
      "domestic_violence" : "Violência doméstica",
      "drug_possession" : "Posse de drogas",
      "duis_reckless_driving" : "Condução sob a influência de substâncias psicoativas e condução imprudente",
      "expungement" : "Expurgo",
      "federal_crimes" : "Crimes Federais",
      "felonies" : "Delitos",
      "petty_crimes_misdemeanors" : "Crimes e contravenções de pets",
      "restraining_orders" : "Ordens de restrição",
      "sex_offenses" : "Crimes sexuais",
      "three_strikes_law" : "Lei das três infrações",
      "dance_instructor_african" : "Africano",
      "dance_instructor_ballet" : "Balé",
      "dance_instructor_ballroom" : "Salão de Baile",
      "dance_instructor_belly" : "Barriga",
      "dance_instructor_bollywood" : "Bollywood",
      "dance_instructor_contemporary" : "Contemporâneo",
      "dance_instructor_folk_traditional" : "Folk e tradicional",
      "dance_instructor_hip_hop" : "Hip Hop",
      "dance_instructor_jazz" : "Jazz",
      "dance_instructor_kids_classes" : "Aulas para crianças",
      "dance_instructor_latin" : "Latim",
      "dance_instructor_modern" : "Moderno",
      "dance_instructor_other" : "Outro",
      "dance_instructor_tap" : "Toque",
      "dance_instructor_wedding" : "Casamento",
      "disability_hearings" : "Audiências sobre deficiência",
      "disability_lawyer_other" : "Outro",
      "long_term_disability" : "Incapacidade de longo prazo",
      "short_term_disability" : "Incapacidade temporária",
      "social_security_disability_insurance" : "Seguro de invalidez da previdência social",
      "ssa_claim_reconsideration" : "Reconsideração de pedido de indenização da SSA",
      "ssa_disability_appeals" : "Apelações de deficiência da SSA",
      "ssa_disability_applications" : "Solicitações de benefício por incapacidade da SSA",
      "ssa_disability_benefits" : "Benefícios por incapacidade da SSA",
      "ssa_family_benefits" : "Benefícios familiares da SSA",
      "ssa_impairment_listings" : "Listagens de deficiências da SSA",
      "supplemental_security_income" : "Renda de segurança suplementar",
      "veterans_disability_benefits" : "Benefícios por incapacidade para veteranos",
      "workers_compensation_disability_lawyer" : "Remuneração dos trabalhadores",
      "behind_the_wheel_lessons" : "Aulas Práticas de Direção",
      "commercial_license_training" : "Treinamento de licença comercial",
      "defensive_driving_lessons" : "Aulas de direção defensiva",
      "drivers_education_classes" : "Aulas de educação para motoristas",
      "driving_instructor_other" : "Outro",
      "manual_transmission_lessons" : "Aulas de transmissão manual",
      "motorcycle_lessons" : "Aulas de motocicleta",
      "traffic_school" : "Escola de trânsito",
      "dui_dwi_dui_lawyer" : "Condução sob a influência de substâncias psicoativas",
      "dui_injuries_dui_lawyer" : "Condução sob a influência de substâncias psicoativas com lesão",
      "dui_lawyer_other" : "Outro",
      "dui_with_accident" : "Condução sob a influência de substâncias psicoativas com acidente",
      "felony_dui" : "Crime grave de condução sob a influência de substâncias psicoativas",
      "invalid_tests" : "Testes Inválidos",
      "multiple_offenses" : "Ofensas múltiplas",
      "reckless_driving_dui_lawyer" : "Direção Imprudente",
      "underage_dui" : "Menores de idade conduzindo sob a influência de substâncias psicoativas",
      "electric_car_charger" : "Instalar carregador de carro elétrico",
      "electrician_other" : "Outro",
      "electrician_remodeling" : "Reforma",
      "install_fan" : "Instalar ventilador",
      "install_ground_wire" : "Instalar fio terra",
      "install_light_fixtures" : "Instalar luminárias",
      "install_outdoor_lighting" : "Instalar iluminação externa",
      "install_outlets_switches" : "Instalar tomadas ou interruptores",
      "install_security_system" : "Instalar sistema de segurança",
      "relocate_outlets_switches" : "Realocar tomadas ou interruptores",
      "repair_fan" : "Reparar ventilador",
      "repair_light_fixtures" : "Reparar luminárias",
      "repair_outlets_switches" : "Conserto de tomadas ou interruptores",
      "repair_panel" : "Reparar painel",
      "replace_upgrade_panel" : "Substituir ou atualizar painel",
      "restore_power" : "Restaurar energia",
      "energy_efficiency_pro_other" : "Outro",
      "charitable_giving" : "Doações",
      "contests_litigation" : "Concursos / Litígios",
      "deeds" : "Escrituras",
      "estate_lawyer_other" : "Outro",
      "estate_planning_lawyer" : "Planejamento patrimonial",
      "guardianship_estate_lawyer" : "Tutela",
      "medical_power_of_attorney" : "Procuração médica",
      "power_of_attorney_estate_lawyer" : "Procuração",
      "probate_estate_lawyer" : "Advogado de sucessões",
      "trusts" : "Créditos",
      "wills" : "Testamentos",
      "anniversary_planner" : "Aniversário",
      "baby_shower_planner" : "Chá de bebê",
      "bar_and_bat_mitzvah_planner" : "Bar e Bat Mitsvá",
      "birthday_party" : "Festa de aniversário",
      "children_party" : "Festa Infantil",
      "corporate_and_conference_planner" : "Corporativo e conferência",
      "event_planner_other" : "Outro",
      "quinceanera_planner" : "Quinceanera",
      "religious_event" : "Evento Religioso",
      "retirement_party" : "Festa de Aposentadoria",
      "school_event" : "Evento Escolar",
      "theme_party" : "Festa temática",
      "wedding_and_engagement_planner" : "Casamento e noivado",
      "adoption" : "Adoção",
      "child_support" : "Pensão alimentícia",
      "contested_divorce" : "Divórcio contestado",
      "debt_division" : "Divisão de Dívida",
      "family_lawyer_other" : "Outro",
      "guardianship_family_lawyer" : "Tutela",
      "mediation_family_lawyer" : "Mediação",
      "modifications_of_orders" : "Modificação de pedidos",
      "parent_timesharing" : "Compartilhamento de tempo dos pais",
      "paternity" : "Paternidade",
      "prenuptial_postnuptial_agreements" : "Acordos pré-nupciais e matrimoniais",
      "probate_family_lawyer" : "Homologação",
      "property_divisions" : "Divisão de propriedade",
      "protective_orders_domestic_violence_issues" : "Ordens de Restrição",
      "spousal_support_alimony" : "Pensão alimentícia entre cônjuges e pensão alimentícia",
      "uncontested_divorce" : "Divórcio consensual",
      "custom_construction" : "Construção personalizada",
      "fence_design" : "Design de cerca",
      "fencing_other" : "Outro",
      "installation_fencing_pro" : "Instalação de Cercas",
      "repairs_maintenance_fencing_pro" : "Reparos e Manutenção",
      "education_savings" : "Poupança para educação",
      "estate_financial_planning" : "Planejamento patrimonial",
      "financial_planning" : "Planejamento financeiro",
      "financial_planning_other" : "Outro",
      "home_purchase" : "Compra de casa",
      "insurance" : "Seguro",
      "investment_advising" : "Consultoria de investimentos",
      "retirement_savings" : "Aposentadoria",
      "tax_planning" : "Planejamento tributário",
      "advanced_cardiac_life_support" : "Suporte avançado de vida cardíaca",
      "aed_defibrillator" : "DEA - Desfibrilador",
      "basic_life_support" : "Suporte básico de vida",
      "cpr" : "RCP",
      "first_aid" : "Primeiros Socorros",
      "first_aid_trainer_other" : "Outro",
      "pediatric_advanced_life_support" : "Suporte avançado de vida em pediatria",
      "pediatric_cpr_first_aid" : "RCP Pediátrica e Primeiros Socorros",
      "pet_cpr_first_aid" : "RCP e primeiros socorros para pets",
      "wilderness_first_aid" : "Primeiros socorros em ambientes selvagens",
      "baseboards" : "Rodapés",
      "carpet" : "Carpete",
      "flooring_other" : "Outro",
      "hardwood" : "Madeira de lei",
      "installation_flooring_pro" : "Instalação de pisos",
      "marble" : "Mármore",
      "polishing" : "Polimento de Piso",
      "refinishing" : "Restauração de pisos",
      "repair_maintenance_flooring_pro" : "Reparo e manutenção de pisos",
      "stair_flooring" : "Piso de escada",
      "tile" : "Ladrilho",
      "wood_floor_sanding" : "Lixamento de Piso de Madeira",
      "basement_waterproofing" : "Impermeabilização de porão",
      "crawl_spaces" : "Fundações do espaço subterrâneo",
      "foundation_drainage" : "Drenagem de Fundação",
      "foundation_installation" : "Instalação da fundação",
      "foundation_pro_other" : "Outro",
      "foundation_raising" : "Aumento da fundação",
      "repairs_maintenance_foundation_pro" : "Reparos e Manutenção",
      "slab_foundation" : "Fundação de laje",
      "steel_pier_pilings" : "Estacas de aço para pilares",
      "water_moisture_control" : "Controle de água e umidade",
      "burials" : "Sepultamentos",
      "caskets" : "Caixões",
      "cremation" : "Cremação",
      "funeral_home_flowers" : "Flores",
      "funeral_home_other" : "Outro",
      "funeral_home_transportation_transfers" : "Transporte e transferências",
      "funeral_home_veteran_services" : "Serviços para Veteranos",
      "funerals" : "Funerais",
      "gravestones" : "Lápides",
      "grief_services" : "Serviços de assistência ao luto",
      "memorials" : "Registros históricos",
      "urns" : "Urnas",
      "garage_door_other" : "Outro",
      "general_maintenance" : "Manutenção geral",
      "install_garage_door" : "Instalar porta de garagem",
      "install_opener" : "Instalar mecanismo de abertura",
      "repair_cables" : "Reparar Cabos",
      "repair_garage_door" : "Reparar porta de garagem",
      "repair_gate" : "Reparar portão",
      "repair_rollers_tracks" : "Conserto de rolos e trilhos",
      "replace_door_panels" : "Substituir painéis de porta",
      "replace_opener" : "Substituir abertura",
      "replace_springs" : "Substituir molas",
      "accessory_buildings" : "Edificações acessórias",
      "bathroom_remodel" : "Remodelação de banheiros",
      "decks_patio" : "Decks e pátios",
      "exterior_finishing" : "Acabamento Externo",
      "foundations_concrete" : "Fundações e Concreto",
      "general_contractor_commercial_projects" : "Projetos comerciais",
      "general_contractor_other" : "Outro",
      "home_addition" : "Ampliação de casas",
      "home_building" : "Construção de casas",
      "home_remodel_renovation" : "Remodelação e renovação de casas",
      "interior_finishing" : "Acabamento Interno",
      "kitchen_remodel" : "Reforma de cozinhas",
      "roofing" : "Cobertura",
      "assemble_furniture" : "Montar Móveis",
      "clean_gutters" : "Limpeza de calhas",
      "handyman_other" : "Outro",
      "install_drywall" : "Instalar drywall",
      "install_flooring" : "Instalar piso",
      "install_tile" : "Instalação de ladrilhos",
      "install_water_fixtures" : "Instalar acessórios hidráulicos",
      "mount_tv" : "Montar TV",
      "paint_indoors" : "Pintar ambientes internos",
      "paint_outdoors" : "Pinte ao ar livre",
      "repair_drywall" : "Reparar Drywall",
      "repair_flooring" : "Reparo de pisos",
      "repair_water_fixtures" : "Reparar acessórios hidráulicos",
      "replace_tile" : "Substituir azulejo",
      "buyer_seller_inspection" : "Inspeção de comprador e vendedor",
      "commercial_properties" : "Propriedades Comerciais",
      "fire_safety" : "Segurança contra incêndios",
      "fireplace_chimney" : "Lareira e chaminé",
      "full_home_inspection" : "Inspeção residencial completa",
      "home_inspector_electrical" : "Elétrica",
      "home_inspector_foundation" : "Fundamentos",
      "home_inspector_hvac" : "HVAC",
      "home_inspector_mold" : "Mofo",
      "home_inspector_new_construction" : "Nova construção",
      "home_inspector_other" : "Outro",
      "home_inspector_plumbing" : "Encanamento",
      "home_inspector_roof" : "Telhado",
      "home_inspector_structural" : "Estrutural",
      "home_warranty" : "Garantia residencial",
      "water_testing" : "Teste de Água",
      "well_or_septic_system" : "Poço ou sistema séptico",
      "wood_insects" : "Madeira e Insetos",
      "access_control" : "Controle de acesso",
      "alarm_systems" : "Sistemas de Alarme",
      "commercial_security_systems" : "Sistemas de segurança comercial",
      "fire_smoke_detection" : "Detecção de incêndio e fumaça",
      "home_security_doors" : "Portas",
      "home_security_locks" : "Fechaduras",
      "home_security_other" : "Outro",
      "home_security_windows" : "Janelas",
      "monitoring_services" : "Serviços de monitoramento",
      "residential_security_systems" : "Sistemas de segurança residencial",
      "smart_home_integration" : "Integração de casa inteligente",
      "video_surveillance" : "Vigilância por vídeo",
      "audio_video_installation" : "Instalação de áudio e vídeo",
      "commercial_projects" : "Projetos comerciais",
      "home_theater_design" : "Design de home theater",
      "home_theater_lighting" : "Iluminação",
      "home_theater_other" : "Outro",
      "home_theater_smart_home_integration" : "Integração de casa inteligente",
      "install_tv" : "Instalar TV",
      "network_it_services" : "Serviços de rede e TI",
      "outdoor_installations" : "Instalações ao ar livre",
      "soundproofing" : "Isolamento Acústico",
      "whole_house_audio_video" : "Áudio e vídeo para toda a casa",
      "ac_maintenance" : "Manutenção de AC",
      "clean_ducts_vents" : "Limpar dutos e aberturas",
      "ductless_heating_and_ac_services" : "Serviços de aquecimento e ar condicionado sem dutos",
      "heating_maintenance" : "Manutenção de aquecimento",
      "hvac_maintenance" : "Manutenção de HVAC",
      "hvac_other" : "Outro",
      "install_ac" : "Instalar AC",
      "install_ducts_vents" : "Instalar dutos e ventiladores",
      "install_heating_system" : "Instalar sistema de aquecimento",
      "install_thermostat" : "Instalar termostato",
      "repair_ac" : "Conserto de ar condicionado",
      "repair_ducts_vents" : "Conserto de dutos e ventilação",
      "repair_heating_system" : "Conserto do sistema de aquecimento",
      "repair_hvac" : "Conserto do sistema de climatização",
      "repair_thermostat" : "Conserto de termostato",
      "asylum" : "Asilo",
      "citizenship" : "Cidadania",
      "deportation" : "Deportação",
      "family_based_immigration" : "Imigração familiar",
      "green_card" : "Green Card",
      "immigration_lawyer_other" : "Outro",
      "investment_visa" : "Visto de investimento",
      "outbound_work_permits" : "Permissões de trabalho enviadas",
      "student_visa" : "Visto de estudante",
      "visitor_visa" : "Visto de visitante",
      "work_visa" : "Visto de Trabalho",
      "appliance_selection" : "Seleção de eletrodomésticos",
      "cabinetry_molding_hardware_design" : "Design de armários e ferragens",
      "decorating" : "Decorando",
      "door_design" : "Design de portas",
      "exterior_building_design" : "Design de edifícios exteriores",
      "flooring_selection" : "Seleção de Pisos",
      "interior_designer_other" : "Outro",
      "landscaping_design" : "Design de paisagismo",
      "lighting_design" : "Design de iluminação",
      "multifamily_housing_design" : "Design de habitação multifamiliar",
      "room_planning" : "Planejamento de salas",
      "stone_brick_stucco_design" : "Design de pedra, tijolo e estuque",
      "window_design" : "Design de janelas",
      "advertisements" : "Anúncios",
      "copyright" : "Direitos autorais",
      "export_control" : "Controle de exportação",
      "franchises" : "Franquias",
      "international_ip" : "IP Internacional",
      "ip_lawyer_other" : "Outro",
      "ip_strategy" : "Estratégia de propriedade intelectual",
      "ip_transactions" : "Transações de propriedade intelectual",
      "licensing" : "Licenciamento",
      "litigation_ip_lawyer" : "Litígio",
      "non_disclosure_agreements_ip_lawyer" : "Acordos de confidencialidade",
      "patents" : "Patentes",
      "technology_transfer" : "Transferência de tecnologia",
      "trade_secrets" : "Segredos Comerciais",
      "trademarks" : "Marcas registradas",
      "appliance_removal" : "Remoção de eletrodomésticos",
      "construction_waste_removal" : "Remoção de Resíduos de Construção",
      "donation_pickup" : "Coleta de Doações",
      "electronic_waste_removal" : "Remoção de resíduos eletrônicos",
      "furniture_removal" : "Remoção de móveis",
      "general_junk_removal" : "Remoção geral de entulho",
      "hazardous_waste_removal" : "Remoção de Resíduos Perigosos",
      "house_garage_cleanout" : "Limpeza de casa/garagem",
      "junk_removal_other" : "Outro",
      "yard_waste_removal" : "Remoção de resíduos de jardinagem",
      "employment_contracts_labor_lawyer" : "Contratos de trabalho",
      "employment_law_labor_lawyer" : "Direito do Trabalho",
      "exempt_employee_status" : "Status de funcionário isento",
      "labor_law" : "Lei trabalhista",
      "labor_lawyer_other" : "Outro",
      "labor_negotiations" : "Negociações trabalhistas",
      "privacy_rights" : "Direitos de privacidade",
      "sexual_harassment" : "Assédio Sexual",
      "unpaid_overtime" : "Horas extras não pagas",
      "whistle_blowing" : "Denúncia de Irregularidades",
      "workers_compensation_labor_lawyer" : "Remuneração dos trabalhadores",
      "wrongful_termination" : "Rescisão injusta",
      "artificial_turf_installation" : "Instalação de grama sintética",
      "concrete_masonry" : "Disposição irregular de concreto",
      "driveway_landscaping" : "Paisagismo de entrada de automóveis",
      "garden_decorations" : "Decorações de jardim",
      "grading_resloping" : "Nivelamento e reclinação",
      "hardscapes" : "Paisagismo",
      "landscape_design" : "Design de paisagem",
      "landscape_installations" : "Instalações paisagísticas",
      "landscaper_other" : "Outro",
      "outdoor_steps" : "Degraus Externos",
      "outdoor_water_feature" : "Recursos hídricos externos",
      "paving_driveway_walkway" : "Pavimentação de calçadas ou passarelas",
      "retaining_walls" : "Muros de contenção",
      "sidewalk_walkway_landscaping" : "Paisagismo de passarelas",
      "sod_seeding" : "Grama e semeadura",
      "stone_masonry" : "Disposição irregular de pedra",
      "arabic" : "Árabe",
      "english" : "English",
      "french" : "French",
      "german" : "German",
      "hebrew" : "Hebraico",
      "italian" : "Italian",
      "japanese" : "Japanese",
      "korean" : "Korean",
      "language_instructor_other" : "Outro",
      "mandarin" : "Mandarim",
      "portuguese" : "Português",
      "russian" : "Russian",
      "sign_language" : "Língua de sinais",
      "spanish" : "Spanish",
      "irrigation_system_repair_maintenance" : "Reparo/Manutenção de Sistema de Irrigação",
      "lawn_care_other" : "Outro",
      "lawn_mowing_maintenance" : "Corte de grama / manutenção",
      "lawn_pest_control" : "Controle de pragas em gramados",
      "mulching" : "Cobertura morta",
      "seeding" : "Semeadura",
      "sod_installation" : "Instalação de Grama",
      "weed_control" : "Controle de ervas daninhas",
      "yard_cleanup" : "Limpeza de quintal",
      "appeals" : "Apelações",
      "case_assessment_litigation_lawyer" : "Avaliação de caso",
      "civil_litigation" : "Litígio Civil",
      "commercial_litigation" : "Litígio Comercial",
      "contracts_and_agreements" : "Contratos e Acordos",
      "criminal_litigation" : "Litígio criminal",
      "litigation_lawyer_other" : "Outro",
      "mediation_litigation_lawyer" : "Mediação",
      "settlements" : "Pagamentos",
      "building_lockout" : "Bloqueio de construção",
      "copy_building_key" : "Copiar chaves de construção",
      "copy_vehicle_key" : "Copiar chave de veículo",
      "install_hardware" : "Instalar equipamentos",
      "locksmith_other" : "Outro",
      "new_key_fob" : "Novo chaveiro",
      "rekey_lock" : "Reconfigurar fechadura",
      "repair_hardware" : "Reparar hardware",
      "vehicle_lockout" : "Desbloqueio de veículos",
      "consent_issues" : "Problemas de consentimento",
      "diagnosis_errors" : "Erros de diagnóstico",
      "malpractice_lawyer_other" : "Outro",
      "medical_negligence" : "Negligência Médica",
      "treatment_errors" : "Erros de Tratamento",
      "massage_center_other" : "Outro",
      "massage_school_advanced_neuromuscular_therapy" : "Terapia Neuromuscular Avançada",
      "massage_school_business_and_ethics" : "Negócios e ética",
      "massage_school_clinical_therapies" : "Terapias clínicas",
      "massage_school_continuing_education" : "Educação continuada",
      "massage_school_deep_tissue_massage" : "Massagem de tecidos profundos",
      "massage_school_energetics" : "Energética",
      "massage_school_hydrotherapy" : "Hidroterapia",
      "massage_school_lymphatic_massage" : "Massagem Linfática",
      "massage_school_online_massage_therapy" : "Terapia de massagem on-line",
      "massage_school_other" : "Outro",
      "massage_school_prenatal_massage" : "Massagem Pré-natal",
      "massage_school_sports_massage" : "Massagem Esportiva",
      "massage_school_student_massage_clinic" : "Clínica de massagem para estudantes",
      "massage_school_swedish_massage" : "Massagem sueca",
      "massage_theory" : "Teoria da Massagem",
      "massage_therapy_training" : "Treinamento em massoterapia",
      "in_state_move" : "Mudança dentro do estado",
      "local_move" : "Mudança local",
      "mover_other" : "Outro",
      "moving_junk_removal" : "Remoção de lixo",
      "moving_storage" : "Armazenamento",
      "out_of_state_move" : "Mudança para fora do estado",
      "oversized_item_move" : "Mover item de grandes dimensões",
      "packing_unpacking" : "Empacotamento / Desempacotamento",
      "senior_move" : "Mudança de idoso",
      "vehicle_transport" : "Transporte de Veículos",
      "cardiac_care" : "Cuidados Cardíacos",
      "general_medical_care" : "Cuidados Médicos Gerais",
      "hospice" : "Hospício",
      "iv_therapy" : "Terapia IV",
      "nursing_home_meal_services" : "Serviços de refeição",
      "nursing_home_memory_care" : "Cuidados com a Memória",
      "nursing_home_other" : "Outro",
      "nursing_home_pain_management" : "Gerenciamento da dor",
      "nursing_home_rehabilitation_services" : "Serviços de Reabilitação",
      "nursing_home_wellness_programs" : "Programas de bem-estar",
      "outpatient_rehabilitation" : "Reabilitação Ambulatorial",
      "post_hospital_care" : "Cuidados pós-hospitalares",
      "respiratory_and_pulmonary_care" : "Cuidados Respiratórios e Pulmonares",
      "senior_activity_programs" : "Programas de atividades para idosos",
      "short_term_rehabilitation" : "Reabilitação de curto prazo",
      "wound_care" : "Tratamento de feridas",
      "exterior_painting" : "Pintura Externa",
      "interior_painting" : "Pintura Interna",
      "paint_cabinets" : "Pintar armários",
      "paint_doors" : "Pintar Portas",
      "painter_other" : "Outro",
      "repair_water_damage" : "Reparo de danos causados pela água",
      "staining" : "Coloração",
      "assault_battery" : "Agressão & Lesão Corporal",
      "auto_accidents" : "Acidentes de carro",
      "bicycle_accidents" : "Acidentes de bicicleta",
      "catastrophic_injuries" : "Lesões catastróficas",
      "dog_bites" : "Mordidas de cães",
      "dui_injuries_personal_injury_lawyer" : "Lesões causadas por dirigir sob a influência de substâncias psicoativas",
      "medical_malpractice" : "Negligência médica",
      "motorcycle_accidents" : "Acidentes de moto",
      "pain_suffering" : "Dor e sofrimento",
      "pedestrian_accidents" : "Acidentes com pedestres",
      "personal_injury_lawyer_other" : "Outro",
      "product_liability" : "Responsabilidade pelo produto",
      "slip_fall" : "Escorregar e cair",
      "uninsured_motorist_claims" : "Reivindicações de seguro para motoristas",
      "workers_compensation_personal_injury_lawyer" : "Remuneração dos trabalhadores",
      "wrongful_death" : "Morte por negligência",
      "aerobics" : "Aeróbica",
      "athletic_performance" : "Desempenho atlético",
      "circuit_training" : "Treinamento em circuito",
      "endurance" : "Resistência",
      "fitness_assessment" : "Avaliação de aptidão física",
      "hiit" : "HIIT",
      "nutritional_counseling" : "Aconselhamento nutricional",
      "personal_trainer_other" : "Outro",
      "strength_conditioning" : "Força e Condicionamento",
      "weight_loss" : "Perda de Peso",
      "yoga" : "Ioga",
      "ants" : "Formigas",
      "bed_bugs" : "Percevejos",
      "bees" : "Abelhas",
      "cockroaches" : "Baratas",
      "fleas_or_mites" : "Pulgas ou Ácaros",
      "hornets_or_wasps" : "Vespas ou marimbondos",
      "mosquitoes" : "Mosquitos",
      "pest_control_other" : "Outro",
      "pest_inspection" : "Inspeção",
      "rodents" : "Roedores",
      "spiders" : "Aranhas",
      "termites" : "Cupins",
      "wildlife" : "Vida selvagem",
      "pet_adoption_birds" : "Aves",
      "pet_adoption_cats" : "Gatos",
      "pet_adoption_dogs" : "Cães",
      "pet_adoption_farm_animals" : "Animais de fazenda",
      "pet_adoption_fish" : "Peixe",
      "pet_adoption_other" : "Outro",
      "pet_adoption_reptiles" : "Répteis",
      "pet_adoption_small_mammals" : "Pequenos mamíferos",
      "pet_adoption_special_needs_animals" : "Animais com necessidades especiais",
      "cat_boarding" : "Hospedagem para gatos",
      "cat_grooming" : "Tosa para gatos",
      "cat_sitting_in_home" : "Serviço de cat sitter em casa",
      "dog_boarding" : "Hospedagem para cães",
      "dog_boarding_with_training" : "Hospedagem de cães com cursos",
      "dog_daycare" : "Creche para cães",
      "dog_grooming" : "Tosa para cães",
      "dog_sitting_in_home" : "Cuidado de cães (em domicílio)",
      "dog_training" : "Treinamento de cães",
      "dog_walking" : "Passeio com cães",
      "other_pet_boarding" : "Outros serviços de hospedagem para pets",
      "other_pet_daycare" : "Outros serviços de creche para pets",
      "other_pet_grooming" : "Outros serviços de tosa para pets",
      "other_pet_sitting_in_home" : "Serviço de pet sitter em casa",
      "pet_boarding_other" : "Outro",
      "cat_bathing" : "Banho para gatos",
      "cat_ear_cleaning" : "Limpeza de orelhas de gato",
      "cat_grooming_and_styling" : "Tosa e estilização para gatos",
      "cat_nail_trimming" : "Corte de unhas de gatos",
      "dog_anal_gland_expression" : "Expressão da glândula anal do cão",
      "dog_bathing_and_blow_dry" : "Banho e secagem de cães",
      "dog_ear_cleaning" : "Limpeza de orelhas de cachorro",
      "dog_flea_and_tick_treatment" : "Tratamento contra pulgas e carrapatos em cães",
      "dog_full_service_grooming" : "Serviço completo de tosa para cães",
      "dog_grooming_and_styling" : "Tosa e estilização para cães",
      "dog_nail_trimming" : "Corte de unhas de cachorro",
      "dog_teeth_brushing" : "Limpeza dentária para cães",
      "pet_grooming_other" : "Outro",
      "aggressive_dog_training" : "Treinamento de cães agressivos",
      "behavior_modification" : "Modificação de Comportamento",
      "obedience_training" : "Treinamento de obediência",
      "offleash_training" : "Treinamento sem coleira",
      "pet_trainer_other" : "Outro",
      "puppy_training" : "Treinamento de filhotes",
      "service_animal_training" : "Cursos de animais de serviço",
      "sport_trick_training" : "Treinamento esportivo ou de truques",
      "training_other_animals" : "Treinamento para outros animais",
      "corporate_photo" : "Corporativo",
      "events_and_parties_photo" : "Eventos e festas",
      "family_and_group_photo" : "Família e Grupo",
      "headshots_and_portraits" : "Fotos de rosto e retratos",
      "individual_photo" : "Individual",
      "maternity_and_newborn_photo" : "Maternidade e recém-nascido",
      "photographer_other" : "Outro",
      "product_photo" : "Produto",
      "real_estate_photo" : "Imóveis",
      "school_portraits" : "Retratos escolares",
      "wedding_and_engagement_photo" : "Casamento e Noivado",
      "find_leak" : "Encontrar e reparar vazamentos",
      "install_faucet" : "Instalar torneira",
      "install_garbage_disposal" : "Instalar triturador de lixo",
      "install_shower" : "Instalar chuveiro",
      "install_toilet" : "Instalar vaso sanitário",
      "install_water_heater" : "Instalar aquecedor de água",
      "plumbing_other" : "Outro",
      "repair_faucet" : "Reparar torneira",
      "repair_garbage_disposal" : "Conserto de triturador de lixo",
      "repair_outdoor_systems" : "Conserto de sistemas externos",
      "repair_pipe" : "Reparar tubulação",
      "repair_sewer" : "Reparar esgoto",
      "repair_shower" : "Reparar chuveiro",
      "repair_toilet" : "Reparar vaso sanitário",
      "repair_water_heater" : "Reparar aquecedor de água",
      "unclog_drain" : "Desentupir ralo",
      "commercial_pool_cleaning_maintenance" : "Limpeza e manutenção de piscinas comerciais",
      "equipment_maintenance_repair" : "Reparo e manutenção de equipamentos",
      "one_time_pool_cleaning" : "Limpeza única da piscina",
      "ongoing_pool_cleaning" : "Limpeza contínua da piscina",
      "pool_cleaner_other" : "Outro",
      "pool_cleaner_water_features" : "Recursos hídricos",
      "seasonal_opening_closing" : "Abertura e fechamento sazonais",
      "spa_hot_tub_cleaning" : "Limpeza de Spa e Banheira de Hidromassagem",
      "spa_hot_tub_repairs" : "Conserto de spas e banheiras de hidromassagem",
      "tile_pool_wall_cleaning" : "Limpeza de azulejos e paredes de piscina",
      "water_testing_balancing" : "Teste e balanceamento de água",
      "jetted_lap_pools" : "Piscinas de Raia com Jatos",
      "pool_construction" : "Construção de Piscinas",
      "pool_contractor_commercial_projects" : "Projetos comerciais",
      "pool_contractor_custom_designs" : "Designs personalizados",
      "pool_contractor_other" : "Outro",
      "pool_contractor_renovation" : "Reforma",
      "pool_contractor_repair_cracks" : "Reparo de rachaduras",
      "pool_contractor_repair_tile" : "Reparar azulejos",
      "pool_contractor_resurfacing" : "Repavimentação",
      "pool_contractor_water_features" : "Recursos hídricos",
      "pool_hot_tub_equipment" : "Equipamento de piscina e banheira de hidromassagem",
      "spa_hot_tub_installation" : "Instalação de Spa e Banheira de Hidromassagem",
      "bilingual_programs" : "Programas Bilíngues",
      "early_preschool" : "Pré-escola precoce",
      "full_day_preschool" : "Pré-escola em tempo integral",
      "half_day_preschool" : "Pré-escola de meio período",
      "kindergarten_classes" : "Aulas de jardim de infância",
      "montessori_programs" : "Programas Montessori",
      "play_based_preschool" : "Pré-escola baseada em brincadeiras",
      "preschool_infant_programs" : "Programas para bebês",
      "preschool_other" : "Outro",
      "reggio_emilia_preschool" : "Pré-escola Reggio Emilia",
      "special_needs_programs" : "Programas especiais",
      "summer_camp" : "Acampamento de Verão",
      "waldorf_preschool" : "Pré-escola Waldorf",
      "psychologist_other" : "Outro",
      "buyer_agent" : "Agente do Comprador",
      "first_time_home_buyer" : "Comprador de casa pela primeira vez",
      "foreclosed_properties" : "Propriedades retomadas",
      "luxury_properties" : "Propriedades de luxo",
      "new_construction" : "Nova construção",
      "property_management" : "Gestão de propriedades",
      "real_estate_agent_other" : "Outro",
      "relocation" : "Realocação",
      "rentals" : "Aluguéis",
      "sellers_agent" : "Agente do vendedor",
      "commercial_real_estate" : "Imóveis comerciais",
      "easements" : "Servidões",
      "encroachment" : "Invasão",
      "foreclosure_real_esate_lawyer" : "Execução hipotecária",
      "landlord_tenant_law" : "Direito do proprietário e do inquilino",
      "litigation_real_estate_lawyer" : "Litígio",
      "mortgage_lending_law" : "Direito hipotecário e de empréstimos",
      "neighbor_hoa_disputes" : "Disputas entre vizinhos e associação de moradores",
      "property_damage" : "Danos materiais",
      "purchase_agreements" : "Contratos de compra",
      "real_estate_contracts_transactions" : "Vendas imobiliárias",
      "real_estate_lawyer_other" : "Outro",
      "residential_real_estate" : "Imobiliário residencial",
      "title_services" : "Serviços de títulos",
      "trespassing" : "Invasão",
      "rehab_other" : "Outro",
      "attic_venting" : "Ventilação do sótão",
      "gutter_installation" : "Instalação de calha",
      "gutter_repair" : "Reparo de calhas",
      "roof_inspection" : "Inspeção de telhado",
      "roof_installation" : "Instalação de Telhado",
      "roof_repair" : "Reparo de Telhado",
      "roofer_other" : "Outro",
      "skylight_installation" : "Instalação de Claraboia",
      "skylight_repair" : "Reparo de claraboia",
      "storm_wind_damage_roof_repair" : "Reparo de Danos no Telhado",
      "sewage_cleaning" : "Limpeza",
      "sewage_excavation" : "Escavação",
      "sewage_inspection" : "Inspeção",
      "sewage_installation" : "Instalação",
      "sewage_locating" : "Localizando",
      "sewage_maintenance_repairs" : "Manutenção e Reparos",
      "sewage_pro_other" : "Outro",
      "sewage_pumping" : "Bombeamento",
      "sewage_removal_demolition" : "Remoção ou Demolição",
      "remodeling_siding_pro" : "Reforma",
      "repair_maintenance_siding_pro" : "Reparação e manutenção",
      "siding_installation" : "Instalação de revestimentos",
      "siding_pro_other" : "Outro",
      "siding_removal" : "Remoção de revestimento",
      "smart_home_other" : "Outro",
      "commercial_snow_removal" : "Remoção de neve comercial",
      "residential_plowing" : "Aragem residencial",
      "residential_shoveling_blowing" : "Remoção de neve residencial com pá e soprador",
      "salt_sand_deicing" : "Sal, areia e degelo",
      "snow_relocation" : "Realocação de neve",
      "snow_removal_other" : "Outro",
      "body_polish" : "Esfoliação corporal",
      "body_wrap" : "Envoltório corporal",
      "facial" : "Facial",
      "hydrotherapy" : "Hidroterapia",
      "manicure" : "Manicure",
      "massage" : "Massagem",
      "pedicure" : "Pedicure",
      "peels" : "Peelings",
      "spa_other" : "Outro",
      "spa_packages" : "Pacotes de spa",
      "tanning" : "Bronzeamento",
      "waxing" : "Depilação com cera",
      "civil_tax_litigation" : "Litígio fiscal civil",
      "corporate_taxes" : "Impostos corporativos",
      "criminal_tax_litigation" : "Litígio fiscal criminal",
      "estate_tax_planning" : "Planejamento de imposto sobre patrimônio",
      "failure_to_file" : "Falha em arquivar",
      "innocent_spouse_relief" : "Alívio para cônjuge inocente",
      "international_tax_services" : "Serviços fiscais internacionais",
      "irs_tax_problems" : "Problemas fiscais com o IRS",
      "non_collectible_status" : "Status não cobrável",
      "offer_in_compromise" : "Oferta de compromisso",
      "tax_audits" : "Auditorias fiscais",
      "tax_lawyer_other" : "Outro",
      "tax_liens_levies" : "Penhoras e tributos",
      "tax_planning_lawyer" : "Planejamento tributário",
      "tax_relief" : "Alívio fiscal",
      "accounting_support" : "Suporte contábil",
      "business_incorporation_restructuring" : "Incorporação e reestruturação",
      "cryptocurrency_taxes" : "Impostos sobre criptomoedas",
      "irs_audit_representation" : "Representação em Auditoria do IRS",
      "irs_filing" : "Declaração de Imposto de Renda",
      "irs_problem_consulting" : "Consultoria para problemas com o IRS",
      "new_business_services" : "Novos serviços da empresa",
      "payroll_support" : "Suporte de Folha de Pagamento",
      "tax_planning_tax_specialist" : "Planejamento tributário",
      "tax_preparation" : "Preparação de imposto",
      "tax_problem_consulting_tax_specialist" : "Consultoria em questões tributárias",
      "tax_specialist_other" : "Outro",
      "therapist_other" : "Outro",
      "battery_service" : "Serviço de Bateria",
      "car_towing" : "Reboque de Carro",
      "fuel_delivery" : "Entrega de Combustível",
      "local_hauling" : "Transporte local",
      "long_distance_hauling" : "Transporte de longa distância",
      "motorcycle_towing" : "Reboque de motocicleta",
      "special_vehicle_towing" : "Reboque de veículos especiais",
      "tire_change" : "Troca de pneu",
      "towing_other" : "Outro",
      "case_assessment_traffic_lawyer" : "Avaliação de Caso",
      "cdl_traffic_ticket" : "Multa de trânsito com carteira profissional (C, D ou E)",
      "dui_dwi_traffic_lawyer" : "Condução sob influência de substâncias psicoativas",
      "fixit_ticket" : "Multa de reparação",
      "parking_ticket" : "Multa de estacionamento",
      "reckless_driving_traffic_lawyer" : "Direção Imprudente",
      "red_light_ticket" : "Multa por sinal vermelho",
      "speeding_ticket" : "Multa por excesso de velocidade",
      "suspended_license" : "Licença suspensa",
      "traffic_lawyer_other" : "Outro",
      "traffic_ticket" : "Multa de trânsito",
      "cabling_and_bracing" : "Cabeamento e reforço",
      "stump_removal" : "Remoção de Tocos",
      "tree_planting" : "Plantio de Árvores",
      "tree_removal" : "Remoção de Árvores",
      "tree_service_other" : "Outro",
      "tree_transplanting" : "Transplante de Árvores",
      "tree_trimming_and_pruning" : "Corte e poda de árvores",
      "tutor_computer_science" : "Ciência da Computação",
      "tutor_foreign_languages" : "Idiomas estrangeiros",
      "tutor_geography" : "Geografia",
      "tutor_government_and_economics" : "Governo e economia",
      "tutor_history" : "Histórico",
      "tutor_homework_help" : "Ajuda com a lição de casa",
      "tutor_math" : "Matemática",
      "tutor_other" : "Outro",
      "tutor_reading_and_writing" : "Leitura e escrita",
      "tutor_science" : "Ciência",
      "tutor_special_education" : "Educação Especial",
      "tutor_test_pre_college_entrance" : "Preparação para o teste: ingresso na faculdade",
      "tutor_test_prep_grad_school_entrance" : "Preparação para o teste: ingresso na pós-graduação",
      "tutor_test_prep_k8" : "Preparação para o teste: K-8",
      "area_rug_cleaning" : "Limpeza de tapetes",
      "drapery_and_blind_cleaning" : "Limpeza de Cortinas e Persianas",
      "leather_cleaning" : "Limpeza de Couro",
      "mattress_cleaning" : "Limpeza de colchão",
      "upholstery_cleaner_other" : "Outro",
      "upholstery_cleaning" : "Limpeza de Estofados",
      "upholstery_water_damage_cleanup" : "Limpeza de danos causados pela água",
      "bird_exotic_animal_care" : "Cuidados com aves e animais exóticos",
      "farm_barn_animal_care" : "Cuidados com animais de fazenda e celeiro",
      "microchipping" : "Microchipagem",
      "veterinarian_allergies" : "Alergias",
      "veterinarian_behavior_counseling" : "Aconselhamento Comportamental",
      "veterinarian_dental_care" : "Cuidados dentários",
      "veterinarian_dermatology" : "Dermatologia",
      "veterinarian_emergency_care" : "Atendimento de Emergência",
      "veterinarian_end_of_life_care" : "Cuidados paliativos",
      "veterinarian_examinations" : "Exames",
      "veterinarian_nutrition_counseling" : "Aconselhamento nutricional",
      "veterinarian_other" : "Outro",
      "veterinarian_preventive_care" : "Cuidados Preventivos",
      "veterinarian_spay_neuter" : "Castrar ou Esterilizar",
      "veterinarian_surgery" : "Cirurgia",
      "veterinarian_vaccinations" : "Vacinas",
      "aerial_videography" : "Videografia Aérea",
      "documentary_video_production" : "Produção de Documentários",
      "family_video_production" : "Produção de vídeo familiar",
      "live_streaming" : "Transmissão ao vivo",
      "photography" : "Fotografia",
      "product_demonstrations" : "Demonstração de Produto",
      "promotional_video_production" : "Produção de vídeo promocional",
      "real_estate_video_production" : "Produção de vídeo imobiliário",
      "special_event_video_production" : "Produção de vídeo para eventos especiais",
      "video_editing" : "Edição de Vídeo",
      "videographer_other" : "Outro",
      "voice_overs" : "Locução",
      "wedding_video_production" : "Produção de vídeo de casamento",
      "fire_damage_cleanup_repair" : "Limpeza/reparo de danos causados por incêndio",
      "water_damage_cleanup_repair" : "Limpeza de danos causados pela água",
      "water_damage_flooring" : "Pisos",
      "water_damage_mold_inspection" : "Inspeção de mofo",
      "water_damage_mold_removal" : "Remoção de Mofo",
      "water_damage_other" : "Outro",
      "water_damage_painting" : "Pintura",
      "water_damage_pest_control" : "Controle de pragas",
      "water_damage_plumbing" : "Encanamento",
      "water_damage_remodeling" : "Reforma",
      "water_damage_roofing" : "Cobertura",
      "water_damage_sewage_cleanup" : "Limpeza de esgoto",
      "adult_weight_loss_programs" : "Programas de perda de peso para adultos",
      "diet_and_nutrition_counseling" : "Aconselhamento sobre dieta e nutrição",
      "kids_weight_loss_programs" : "Programas de perda de peso para crianças",
      "metabolic_testing" : "Teste Metabólico",
      "weight_loss_consultation_and_training" : "Consultoria e treinamento",
      "weight_loss_fitness_programs" : "Programas de condicionamento físico",
      "weight_loss_meal_planning" : "Planejamento de Refeições",
      "weight_loss_personal_training" : "Treinamento pessoal",
      "weight_loss_service_other" : "Outro",
      "weight_loss_wellness_programs" : "Programas de bem-estar",
      "glass_and_mirror_cleaning" : "Limpeza de Vidros e Espelhos",
      "gutter_cleaning" : "Limpeza de Calhas",
      "power_pressure_washing" : "Lavagem a pressão/potência",
      "rooftop_skylight_cleaning" : "Limpeza de telhados/claraboias",
      "window_cleaner_other" : "Outro",
      "window_cleaning" : "Limpeza de janelas",
      "door_installation" : "Instalação de portas",
      "door_repair" : "Reparo de portas",
      "glass_installation" : "Instalação de Vidro",
      "window_boardup" : "Tábuas",
      "window_installation" : "Instalação de janelas",
      "window_repair" : "Reparo de janelas",
      "window_repair_other" : "Outro",
      "install_new_wiper_blades" : "Instalar novas palhetas do limpador",
      "repair_power_window" : "Conserto de janela elétrica",
      "repair_water_leak" : "Reparar vazamento de água",
      "repair_windshield" : "Conserto de para-brisa",
      "replace_rear_window" : "Substituir janela traseira",
      "replace_side_view_mirrors" : "Conserto de espelhos laterais",
      "replace_side_window" : "Substituir janela lateral",
      "replace_sunroof" : "Substituir o vidro do teto solar",
      "replace_windshield" : "Substituir para-brisa",
      "windshield_other" : "Outro",
      "ashtanga" : "Ashtanga",
      "hatha" : "Hatha",
      "hot_yoga" : "Hot Yoga",
      "iyengar" : "Iyengar",
      "kundalini" : "Kundalini",
      "meditation" : "Meditação",
      "power_yoga" : "Power Yoga",
      "restorative" : "Restauração",
      "vinyasa" : "Vinyasa",
      "yin" : "Yin",
      "yoga_instructor_other" : "Outro"
    }
  }
}
